/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * faqrun API
 * Admin / Provider 管理API
 * OpenAPI spec version: 1.0
 */
import type {
  AcceptEnterpriseOfferDto,
  AcceptEnterpriseOfferResponseDto,
  AcceptInvitationDto,
  AdminAnalyticsControllerExportArticlesCsvParams,
  AdminAnalyticsControllerExportSearchCsvParams,
  AdminAnalyticsControllerGetAnalyticsSummaryParams,
  AdminAnalyticsControllerGetArticlePerformanceParams,
  AdminAnalyticsControllerGetFeedbackByArticleParams,
  AdminAnalyticsControllerGetFeedbacksWithCommentsParams,
  AdminAnalyticsControllerGetSearchKeywordRankingParams,
  AdminAnalyticsControllerGetSearchZeroResultKeywordsParams,
  AdminArticleControllerFindAllParams,
  AdminMediaControllerFindAllParams,
  AdminMemberControllerFindAllParams,
  AdminProductControllerFindAllParams,
  AdminSubscriptionControllerGetCustomerPortalUrlParams,
  AdminSubscriptionControllerGetDowngradeImpactParams,
  AnalyticsSummaryResponseDto,
  ArticlePerformanceResponseDto,
  ArticleResponseDto,
  AuthControllerVerifyResetTokenParams,
  AuthResponseDto,
  CategoryResponseDto,
  CategoryTreeDto,
  ChangeEmailDto,
  ChangeEnterprisePriceDto,
  ChangePasswordDto,
  CreateArticleDto,
  CreateCategoryDto,
  CreateEnterpriseSubscriptionDto,
  CreateInvitationDto,
  CreateJobFromSessionDto,
  CreateOrganizationDto,
  CreatePreviewDto,
  CreateProductDto,
  CreateProviderUserDto,
  CreateSessionDto,
  CreateTagDto,
  CustomDomainResponseDto,
  CustomerPortalResponseDto,
  DashboardStatsResponseDto,
  DeletionEligibilityResponseDto,
  DowngradeImpactResponseDto,
  DowngradeSubscriptionDto,
  EnterpriseOfferResponseDto,
  EnterprisePriceChangeResultDto,
  EntitlementDto,
  FeedbackByArticleResponseDto,
  FeedbackCommentsResponseDto,
  FeedbackSummaryDto,
  ForgotPasswordDto,
  GenerateDescriptionRequestDto,
  GenerateDescriptionResponseDto,
  GrantInternalDto,
  HealthResponseDto,
  InvitationAdminControllerVerifyParams,
  InvitationResponseDto,
  LoginDto,
  MediaMessageResponseDto,
  MediaResponseDto,
  MemberResponseDto,
  MessageResponseDto,
  OrgUserResponseDto,
  OrganizationProductGroupDto,
  OrganizationResponseDto,
  PaginatedArticleResponseDto,
  PaginatedMediaResponseDto,
  PaginatedMemberResponseDto,
  PaginatedOrgUserResponseDto,
  PaginatedOrganizationResponseDto,
  PaginatedPlanResponseDto,
  PaginatedProductResponseDto,
  PaginatedProviderUserResponseDto,
  PermissionResponseDto,
  PlanDetailResponseDto,
  PreviewResponseDto,
  PreviewUrlResponseDto,
  ProductResponseDto,
  ProductWithApiKeyResponseDto,
  ProfileResponseDto,
  ProviderAuthControllerVerifyResetTokenParams,
  ProviderOrgUserControllerFindAllParams,
  ProviderOrganizationControllerFindAllParams,
  ProviderPlanControllerFindAllParams,
  ProviderProductControllerFindAllParams,
  ProviderUserControllerFindAllParams,
  ProviderUserMessageResponseDto,
  ProviderUserResponseDto,
  RejectEnterpriseOfferDto,
  ResetPasswordDto,
  ScraperJobResponseDto,
  ScraperJobResultResponseDto,
  SearchKeywordRankingResponseDto,
  SearchZeroResultResponseDto,
  SessionResponseDto,
  SetCustomDomainDto,
  SetPermissionDto,
  SignupDto,
  SubscriptionResponseDto,
  SubscriptionStatusDto,
  SwitchOrganizationDto,
  SystemStatsResponseDto,
  TagResponseDto,
  TenantInvitationProviderControllerCancelParams,
  TenantInvitationProviderControllerCreateParams,
  TenantInvitationProviderControllerFindAllParams,
  TenantInvitationProviderControllerResendParams,
  ThemeResponseDto,
  TransferOwnerDto,
  UpdateArticleDto,
  UpdateCategoryDto,
  UpdateMemberDto,
  UpdateOrgUserDto,
  UpdateOrganizationDto,
  UpdatePaymentMethodDto,
  UpdateProductDto,
  UpdateProfileDto,
  UpdateProviderUserDto,
  UpdateThemeDto,
  UpgradeAcceptedDto,
  UpgradeBankTransferInvoiceIssuedDto,
  UpgradeRequiresPaymentMethodDto,
  UpgradeSubscriptionDto,
  VerifyEmailDto,
  VerifySignupDto
} from './faqrunAPI.schemas';

import { customFetch } from '../custom-fetch';

export type authControllerSignupResponse204 = {
  data: void
  status: 204
}

export type authControllerSignupResponse429 = {
  data: void
  status: 429
}

export type authControllerSignupResponseSuccess = (authControllerSignupResponse204) & {
  headers: Headers;
};
export type authControllerSignupResponseError = (authControllerSignupResponse429) & {
  headers: Headers;
};

export type authControllerSignupResponse = (authControllerSignupResponseSuccess | authControllerSignupResponseError)

export const getAuthControllerSignupUrl = () => {




  return `/api/admin/v1/auth/signup`
}

/**
 * @summary セルフサインアップ（確認メール送信）
 */
export const authControllerSignup = async (signupDto: SignupDto, options?: RequestInit): Promise<authControllerSignupResponse> => {

  return customFetch<authControllerSignupResponse>(getAuthControllerSignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(signupDto)
  }
);}



export type authControllerVerifySignupResponse200 = {
  data: AuthResponseDto
  status: 200
}

export type authControllerVerifySignupResponse400 = {
  data: void
  status: 400
}

export type authControllerVerifySignupResponseSuccess = (authControllerVerifySignupResponse200) & {
  headers: Headers;
};
export type authControllerVerifySignupResponseError = (authControllerVerifySignupResponse400) & {
  headers: Headers;
};

export type authControllerVerifySignupResponse = (authControllerVerifySignupResponseSuccess | authControllerVerifySignupResponseError)

export const getAuthControllerVerifySignupUrl = () => {




  return `/api/admin/v1/auth/signup/verify`
}

/**
 * @summary サインアップ確認（アカウント作成 + 自動ログイン）
 */
export const authControllerVerifySignup = async (verifySignupDto: VerifySignupDto, options?: RequestInit): Promise<authControllerVerifySignupResponse> => {

  return customFetch<authControllerVerifySignupResponse>(getAuthControllerVerifySignupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifySignupDto)
  }
);}



export type authControllerLoginResponse200 = {
  data: AuthResponseDto
  status: 200
}

export type authControllerLoginResponse401 = {
  data: void
  status: 401
}

export type authControllerLoginResponseSuccess = (authControllerLoginResponse200) & {
  headers: Headers;
};
export type authControllerLoginResponseError = (authControllerLoginResponse401) & {
  headers: Headers;
};

export type authControllerLoginResponse = (authControllerLoginResponseSuccess | authControllerLoginResponseError)

export const getAuthControllerLoginUrl = () => {




  return `/api/admin/v1/auth/login`
}

/**
 * @summary ログイン
 */
export const authControllerLogin = async (loginDto: LoginDto, options?: RequestInit): Promise<authControllerLoginResponse> => {

  return customFetch<authControllerLoginResponse>(getAuthControllerLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginDto)
  }
);}



export type authControllerRefreshResponse200 = {
  data: AuthResponseDto
  status: 200
}

export type authControllerRefreshResponse401 = {
  data: void
  status: 401
}

export type authControllerRefreshResponseSuccess = (authControllerRefreshResponse200) & {
  headers: Headers;
};
export type authControllerRefreshResponseError = (authControllerRefreshResponse401) & {
  headers: Headers;
};

export type authControllerRefreshResponse = (authControllerRefreshResponseSuccess | authControllerRefreshResponseError)

export const getAuthControllerRefreshUrl = () => {




  return `/api/admin/v1/auth/refresh`
}

/**
 * @summary トークンリフレッシュ
 */
export const authControllerRefresh = async ( options?: RequestInit): Promise<authControllerRefreshResponse> => {

  return customFetch<authControllerRefreshResponse>(getAuthControllerRefreshUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type authControllerSwitchOrganizationResponse200 = {
  data: AuthResponseDto
  status: 200
}

export type authControllerSwitchOrganizationResponse403 = {
  data: void
  status: 403
}

export type authControllerSwitchOrganizationResponseSuccess = (authControllerSwitchOrganizationResponse200) & {
  headers: Headers;
};
export type authControllerSwitchOrganizationResponseError = (authControllerSwitchOrganizationResponse403) & {
  headers: Headers;
};

export type authControllerSwitchOrganizationResponse = (authControllerSwitchOrganizationResponseSuccess | authControllerSwitchOrganizationResponseError)

export const getAuthControllerSwitchOrganizationUrl = () => {




  return `/api/admin/v1/auth/me/switch-organization`
}

/**
 * @summary 操作対象組織を切り替え
 */
export const authControllerSwitchOrganization = async (switchOrganizationDto: SwitchOrganizationDto, options?: RequestInit): Promise<authControllerSwitchOrganizationResponse> => {

  return customFetch<authControllerSwitchOrganizationResponse>(getAuthControllerSwitchOrganizationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(switchOrganizationDto)
  }
);}



export type authControllerLogoutResponse204 = {
  data: void
  status: 204
}

export type authControllerLogoutResponseSuccess = (authControllerLogoutResponse204) & {
  headers: Headers;
};
;

export type authControllerLogoutResponse = (authControllerLogoutResponseSuccess)

export const getAuthControllerLogoutUrl = () => {




  return `/api/admin/v1/auth/logout`
}

/**
 * @summary ログアウト
 */
export const authControllerLogout = async ( options?: RequestInit): Promise<authControllerLogoutResponse> => {

  return customFetch<authControllerLogoutResponse>(getAuthControllerLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type authControllerForgotPasswordResponse204 = {
  data: void
  status: 204
}

export type authControllerForgotPasswordResponseSuccess = (authControllerForgotPasswordResponse204) & {
  headers: Headers;
};
;

export type authControllerForgotPasswordResponse = (authControllerForgotPasswordResponseSuccess)

export const getAuthControllerForgotPasswordUrl = () => {




  return `/api/admin/v1/auth/forgot-password`
}

/**
 * @summary パスワードリセット申請
 */
export const authControllerForgotPassword = async (forgotPasswordDto: ForgotPasswordDto, options?: RequestInit): Promise<authControllerForgotPasswordResponse> => {

  return customFetch<authControllerForgotPasswordResponse>(getAuthControllerForgotPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forgotPasswordDto)
  }
);}



export type authControllerVerifyResetTokenResponse200 = {
  data: void
  status: 200
}

export type authControllerVerifyResetTokenResponse400 = {
  data: void
  status: 400
}

export type authControllerVerifyResetTokenResponseSuccess = (authControllerVerifyResetTokenResponse200) & {
  headers: Headers;
};
export type authControllerVerifyResetTokenResponseError = (authControllerVerifyResetTokenResponse400) & {
  headers: Headers;
};

export type authControllerVerifyResetTokenResponse = (authControllerVerifyResetTokenResponseSuccess | authControllerVerifyResetTokenResponseError)

export const getAuthControllerVerifyResetTokenUrl = (params: AuthControllerVerifyResetTokenParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/auth/reset-password/verify?${stringifiedParams}` : `/api/admin/v1/auth/reset-password/verify`
}

/**
 * @summary パスワードリセットトークン検証
 */
export const authControllerVerifyResetToken = async (params: AuthControllerVerifyResetTokenParams, options?: RequestInit): Promise<authControllerVerifyResetTokenResponse> => {

  return customFetch<authControllerVerifyResetTokenResponse>(getAuthControllerVerifyResetTokenUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type authControllerResetPasswordResponse204 = {
  data: void
  status: 204
}

export type authControllerResetPasswordResponse400 = {
  data: void
  status: 400
}

export type authControllerResetPasswordResponseSuccess = (authControllerResetPasswordResponse204) & {
  headers: Headers;
};
export type authControllerResetPasswordResponseError = (authControllerResetPasswordResponse400) & {
  headers: Headers;
};

export type authControllerResetPasswordResponse = (authControllerResetPasswordResponseSuccess | authControllerResetPasswordResponseError)

export const getAuthControllerResetPasswordUrl = () => {




  return `/api/admin/v1/auth/reset-password`
}

/**
 * @summary パスワードリセット実行
 */
export const authControllerResetPassword = async (resetPasswordDto: ResetPasswordDto, options?: RequestInit): Promise<authControllerResetPasswordResponse> => {

  return customFetch<authControllerResetPasswordResponse>(getAuthControllerResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordDto)
  }
);}



export type adminHealthControllerCheckResponse200 = {
  data: HealthResponseDto
  status: 200
}

export type adminHealthControllerCheckResponseSuccess = (adminHealthControllerCheckResponse200) & {
  headers: Headers;
};
;

export type adminHealthControllerCheckResponse = (adminHealthControllerCheckResponseSuccess)

export const getAdminHealthControllerCheckUrl = () => {




  return `/api/admin/health`
}

/**
 * @summary ヘルスチェック
 */
export const adminHealthControllerCheck = async ( options?: RequestInit): Promise<adminHealthControllerCheckResponse> => {

  return customFetch<adminHealthControllerCheckResponse>(getAdminHealthControllerCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminDashboardControllerGetStatsResponse200 = {
  data: DashboardStatsResponseDto
  status: 200
}

export type adminDashboardControllerGetStatsResponseSuccess = (adminDashboardControllerGetStatsResponse200) & {
  headers: Headers;
};
;

export type adminDashboardControllerGetStatsResponse = (adminDashboardControllerGetStatsResponseSuccess)

export const getAdminDashboardControllerGetStatsUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/dashboard`
}

/**
 * @summary ダッシュボード統計取得
 */
export const adminDashboardControllerGetStats = async (productId: string, options?: RequestInit): Promise<adminDashboardControllerGetStatsResponse> => {

  return customFetch<adminDashboardControllerGetStatsResponse>(getAdminDashboardControllerGetStatsUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminOrganizationControllerCreateResponse201 = {
  data: OrganizationResponseDto
  status: 201
}

export type adminOrganizationControllerCreateResponse400 = {
  data: void
  status: 400
}

export type adminOrganizationControllerCreateResponse403 = {
  data: void
  status: 403
}

export type adminOrganizationControllerCreateResponseSuccess = (adminOrganizationControllerCreateResponse201) & {
  headers: Headers;
};
export type adminOrganizationControllerCreateResponseError = (adminOrganizationControllerCreateResponse400 | adminOrganizationControllerCreateResponse403) & {
  headers: Headers;
};

export type adminOrganizationControllerCreateResponse = (adminOrganizationControllerCreateResponseSuccess | adminOrganizationControllerCreateResponseError)

export const getAdminOrganizationControllerCreateUrl = () => {




  return `/api/admin/v1/organizations`
}

/**
 * @summary 新しい組織を作成（作成者が Owner 兼 ADMIN として登録される。@basicinc.jp / @x.basicinc.jp ユーザのみ許可）
 */
export const adminOrganizationControllerCreate = async (createOrganizationDto: CreateOrganizationDto, options?: RequestInit): Promise<adminOrganizationControllerCreateResponse> => {

  return customFetch<adminOrganizationControllerCreateResponse>(getAdminOrganizationControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createOrganizationDto)
  }
);}



export type adminOrganizationControllerFindMyOrganizationResponse200 = {
  data: OrganizationResponseDto
  status: 200
}

export type adminOrganizationControllerFindMyOrganizationResponse404 = {
  data: void
  status: 404
}

export type adminOrganizationControllerFindMyOrganizationResponseSuccess = (adminOrganizationControllerFindMyOrganizationResponse200) & {
  headers: Headers;
};
export type adminOrganizationControllerFindMyOrganizationResponseError = (adminOrganizationControllerFindMyOrganizationResponse404) & {
  headers: Headers;
};

export type adminOrganizationControllerFindMyOrganizationResponse = (adminOrganizationControllerFindMyOrganizationResponseSuccess | adminOrganizationControllerFindMyOrganizationResponseError)

export const getAdminOrganizationControllerFindMyOrganizationUrl = () => {




  return `/api/admin/v1/organizations/me`
}

/**
 * @summary 自組織情報取得
 */
export const adminOrganizationControllerFindMyOrganization = async ( options?: RequestInit): Promise<adminOrganizationControllerFindMyOrganizationResponse> => {

  return customFetch<adminOrganizationControllerFindMyOrganizationResponse>(getAdminOrganizationControllerFindMyOrganizationUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminOrganizationControllerUpdateMyOrganizationResponse200 = {
  data: OrganizationResponseDto
  status: 200
}

export type adminOrganizationControllerUpdateMyOrganizationResponse400 = {
  data: void
  status: 400
}

export type adminOrganizationControllerUpdateMyOrganizationResponse403 = {
  data: void
  status: 403
}

export type adminOrganizationControllerUpdateMyOrganizationResponseSuccess = (adminOrganizationControllerUpdateMyOrganizationResponse200) & {
  headers: Headers;
};
export type adminOrganizationControllerUpdateMyOrganizationResponseError = (adminOrganizationControllerUpdateMyOrganizationResponse400 | adminOrganizationControllerUpdateMyOrganizationResponse403) & {
  headers: Headers;
};

export type adminOrganizationControllerUpdateMyOrganizationResponse = (adminOrganizationControllerUpdateMyOrganizationResponseSuccess | adminOrganizationControllerUpdateMyOrganizationResponseError)

export const getAdminOrganizationControllerUpdateMyOrganizationUrl = () => {




  return `/api/admin/v1/organizations/me`
}

/**
 * @summary 自組織情報更新
 */
export const adminOrganizationControllerUpdateMyOrganization = async (updateOrganizationDto: UpdateOrganizationDto, options?: RequestInit): Promise<adminOrganizationControllerUpdateMyOrganizationResponse> => {

  return customFetch<adminOrganizationControllerUpdateMyOrganizationResponse>(getAdminOrganizationControllerUpdateMyOrganizationUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrganizationDto)
  }
);}



export type adminOrganizationControllerTransferOwnerResponse201 = {
  data: OrganizationResponseDto
  status: 201
}

export type adminOrganizationControllerTransferOwnerResponse400 = {
  data: void
  status: 400
}

export type adminOrganizationControllerTransferOwnerResponse403 = {
  data: void
  status: 403
}

export type adminOrganizationControllerTransferOwnerResponseSuccess = (adminOrganizationControllerTransferOwnerResponse201) & {
  headers: Headers;
};
export type adminOrganizationControllerTransferOwnerResponseError = (adminOrganizationControllerTransferOwnerResponse400 | adminOrganizationControllerTransferOwnerResponse403) & {
  headers: Headers;
};

export type adminOrganizationControllerTransferOwnerResponse = (adminOrganizationControllerTransferOwnerResponseSuccess | adminOrganizationControllerTransferOwnerResponseError)

export const getAdminOrganizationControllerTransferOwnerUrl = () => {




  return `/api/admin/v1/organizations/transfer-owner`
}

/**
 * @summary オーナー譲渡
 */
export const adminOrganizationControllerTransferOwner = async (transferOwnerDto: TransferOwnerDto, options?: RequestInit): Promise<adminOrganizationControllerTransferOwnerResponse> => {

  return customFetch<adminOrganizationControllerTransferOwnerResponse>(getAdminOrganizationControllerTransferOwnerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(transferOwnerDto)
  }
);}



export type adminProductControllerFindAllResponse200 = {
  data: PaginatedProductResponseDto
  status: 200
}

export type adminProductControllerFindAllResponseSuccess = (adminProductControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type adminProductControllerFindAllResponse = (adminProductControllerFindAllResponseSuccess)

export const getAdminProductControllerFindAllUrl = (params?: AdminProductControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products?${stringifiedParams}` : `/api/admin/v1/products`
}

/**
 * @summary プロダクト一覧取得
 */
export const adminProductControllerFindAll = async (params?: AdminProductControllerFindAllParams, options?: RequestInit): Promise<adminProductControllerFindAllResponse> => {

  return customFetch<adminProductControllerFindAllResponse>(getAdminProductControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminProductControllerCreateResponse201 = {
  data: ProductResponseDto
  status: 201
}

export type adminProductControllerCreateResponseSuccess = (adminProductControllerCreateResponse201) & {
  headers: Headers;
};
;

export type adminProductControllerCreateResponse = (adminProductControllerCreateResponseSuccess)

export const getAdminProductControllerCreateUrl = () => {




  return `/api/admin/v1/products`
}

/**
 * @summary プロダクト作成
 */
export const adminProductControllerCreate = async (createProductDto: CreateProductDto, options?: RequestInit): Promise<adminProductControllerCreateResponse> => {

  return customFetch<adminProductControllerCreateResponse>(getAdminProductControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductDto)
  }
);}



export type adminProductControllerFindOneResponse200 = {
  data: ProductResponseDto
  status: 200
}

export type adminProductControllerFindOneResponseSuccess = (adminProductControllerFindOneResponse200) & {
  headers: Headers;
};
;

export type adminProductControllerFindOneResponse = (adminProductControllerFindOneResponseSuccess)

export const getAdminProductControllerFindOneUrl = (id: string,) => {




  return `/api/admin/v1/products/${id}`
}

/**
 * @summary プロダクト取得
 */
export const adminProductControllerFindOne = async (id: string, options?: RequestInit): Promise<adminProductControllerFindOneResponse> => {

  return customFetch<adminProductControllerFindOneResponse>(getAdminProductControllerFindOneUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminProductControllerUpdateResponse200 = {
  data: ProductResponseDto
  status: 200
}

export type adminProductControllerUpdateResponseSuccess = (adminProductControllerUpdateResponse200) & {
  headers: Headers;
};
;

export type adminProductControllerUpdateResponse = (adminProductControllerUpdateResponseSuccess)

export const getAdminProductControllerUpdateUrl = (id: string,) => {




  return `/api/admin/v1/products/${id}`
}

/**
 * @summary プロダクト更新
 */
export const adminProductControllerUpdate = async (id: string,
    updateProductDto: UpdateProductDto, options?: RequestInit): Promise<adminProductControllerUpdateResponse> => {

  return customFetch<adminProductControllerUpdateResponse>(getAdminProductControllerUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProductDto)
  }
);}



export type adminProductControllerRegenerateApiKeyResponse201 = {
  data: ProductWithApiKeyResponseDto
  status: 201
}

export type adminProductControllerRegenerateApiKeyResponseSuccess = (adminProductControllerRegenerateApiKeyResponse201) & {
  headers: Headers;
};
;

export type adminProductControllerRegenerateApiKeyResponse = (adminProductControllerRegenerateApiKeyResponseSuccess)

export const getAdminProductControllerRegenerateApiKeyUrl = (id: string,) => {




  return `/api/admin/v1/products/${id}/regenerate-api-key`
}

/**
 * @summary APIキー再生成
 */
export const adminProductControllerRegenerateApiKey = async (id: string, options?: RequestInit): Promise<adminProductControllerRegenerateApiKeyResponse> => {

  return customFetch<adminProductControllerRegenerateApiKeyResponse>(getAdminProductControllerRegenerateApiKeyUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminProductControllerRevokeApiKeyResponse200 = {
  data: ProductResponseDto
  status: 200
}

export type adminProductControllerRevokeApiKeyResponseSuccess = (adminProductControllerRevokeApiKeyResponse200) & {
  headers: Headers;
};
;

export type adminProductControllerRevokeApiKeyResponse = (adminProductControllerRevokeApiKeyResponseSuccess)

export const getAdminProductControllerRevokeApiKeyUrl = (id: string,) => {




  return `/api/admin/v1/products/${id}/api-key`
}

/**
 * @summary APIキー失効
 */
export const adminProductControllerRevokeApiKey = async (id: string, options?: RequestInit): Promise<adminProductControllerRevokeApiKeyResponse> => {

  return customFetch<adminProductControllerRevokeApiKeyResponse>(getAdminProductControllerRevokeApiKeyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminThemeControllerFindByProductIdResponse200 = {
  data: ThemeResponseDto
  status: 200
}

export type adminThemeControllerFindByProductIdResponse404 = {
  data: void
  status: 404
}

export type adminThemeControllerFindByProductIdResponseSuccess = (adminThemeControllerFindByProductIdResponse200) & {
  headers: Headers;
};
export type adminThemeControllerFindByProductIdResponseError = (adminThemeControllerFindByProductIdResponse404) & {
  headers: Headers;
};

export type adminThemeControllerFindByProductIdResponse = (adminThemeControllerFindByProductIdResponseSuccess | adminThemeControllerFindByProductIdResponseError)

export const getAdminThemeControllerFindByProductIdUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/themes`
}

/**
 * @summary テーマ取得
 */
export const adminThemeControllerFindByProductId = async (productId: string, options?: RequestInit): Promise<adminThemeControllerFindByProductIdResponse> => {

  return customFetch<adminThemeControllerFindByProductIdResponse>(getAdminThemeControllerFindByProductIdUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminThemeControllerUpdateResponse200 = {
  data: ThemeResponseDto
  status: 200
}

export type adminThemeControllerUpdateResponse404 = {
  data: void
  status: 404
}

export type adminThemeControllerUpdateResponseSuccess = (adminThemeControllerUpdateResponse200) & {
  headers: Headers;
};
export type adminThemeControllerUpdateResponseError = (adminThemeControllerUpdateResponse404) & {
  headers: Headers;
};

export type adminThemeControllerUpdateResponse = (adminThemeControllerUpdateResponseSuccess | adminThemeControllerUpdateResponseError)

export const getAdminThemeControllerUpdateUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/themes`
}

/**
 * @summary テーマ更新
 */
export const adminThemeControllerUpdate = async (productId: string,
    updateThemeDto: UpdateThemeDto, options?: RequestInit): Promise<adminThemeControllerUpdateResponse> => {

  return customFetch<adminThemeControllerUpdateResponse>(getAdminThemeControllerUpdateUrl(productId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateThemeDto)
  }
);}



export type adminArticleControllerFindAllResponse200 = {
  data: PaginatedArticleResponseDto
  status: 200
}

export type adminArticleControllerFindAllResponseSuccess = (adminArticleControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type adminArticleControllerFindAllResponse = (adminArticleControllerFindAllResponseSuccess)

export const getAdminArticleControllerFindAllUrl = (productId: string,
    params?: AdminArticleControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/articles?${stringifiedParams}` : `/api/admin/v1/products/${productId}/articles`
}

/**
 * @summary 記事一覧取得
 */
export const adminArticleControllerFindAll = async (productId: string,
    params?: AdminArticleControllerFindAllParams, options?: RequestInit): Promise<adminArticleControllerFindAllResponse> => {

  return customFetch<adminArticleControllerFindAllResponse>(getAdminArticleControllerFindAllUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminArticleControllerCreateResponse201 = {
  data: ArticleResponseDto
  status: 201
}

export type adminArticleControllerCreateResponseSuccess = (adminArticleControllerCreateResponse201) & {
  headers: Headers;
};
;

export type adminArticleControllerCreateResponse = (adminArticleControllerCreateResponseSuccess)

export const getAdminArticleControllerCreateUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/articles`
}

/**
 * @summary 記事作成
 */
export const adminArticleControllerCreate = async (productId: string,
    createArticleDto: CreateArticleDto, options?: RequestInit): Promise<adminArticleControllerCreateResponse> => {

  return customFetch<adminArticleControllerCreateResponse>(getAdminArticleControllerCreateUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createArticleDto)
  }
);}



export type adminArticleControllerFindByIdResponse200 = {
  data: ArticleResponseDto
  status: 200
}

export type adminArticleControllerFindByIdResponse404 = {
  data: void
  status: 404
}

export type adminArticleControllerFindByIdResponseSuccess = (adminArticleControllerFindByIdResponse200) & {
  headers: Headers;
};
export type adminArticleControllerFindByIdResponseError = (adminArticleControllerFindByIdResponse404) & {
  headers: Headers;
};

export type adminArticleControllerFindByIdResponse = (adminArticleControllerFindByIdResponseSuccess | adminArticleControllerFindByIdResponseError)

export const getAdminArticleControllerFindByIdUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}`
}

/**
 * @summary 記事詳細取得
 */
export const adminArticleControllerFindById = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerFindByIdResponse> => {

  return customFetch<adminArticleControllerFindByIdResponse>(getAdminArticleControllerFindByIdUrl(productId,id),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminArticleControllerUpdateResponse200 = {
  data: ArticleResponseDto
  status: 200
}

export type adminArticleControllerUpdateResponseSuccess = (adminArticleControllerUpdateResponse200) & {
  headers: Headers;
};
;

export type adminArticleControllerUpdateResponse = (adminArticleControllerUpdateResponseSuccess)

export const getAdminArticleControllerUpdateUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}`
}

/**
 * @summary 記事更新
 */
export const adminArticleControllerUpdate = async (productId: string,
    id: string,
    updateArticleDto: UpdateArticleDto, options?: RequestInit): Promise<adminArticleControllerUpdateResponse> => {

  return customFetch<adminArticleControllerUpdateResponse>(getAdminArticleControllerUpdateUrl(productId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateArticleDto)
  }
);}



export type adminArticleControllerSoftDeleteResponse200 = {
  data: ArticleResponseDto
  status: 200
}

export type adminArticleControllerSoftDeleteResponseSuccess = (adminArticleControllerSoftDeleteResponse200) & {
  headers: Headers;
};
;

export type adminArticleControllerSoftDeleteResponse = (adminArticleControllerSoftDeleteResponseSuccess)

export const getAdminArticleControllerSoftDeleteUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}`
}

/**
 * @summary 記事削除（論理削除）
 */
export const adminArticleControllerSoftDelete = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerSoftDeleteResponse> => {

  return customFetch<adminArticleControllerSoftDeleteResponse>(getAdminArticleControllerSoftDeleteUrl(productId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminArticleControllerPublishResponse201 = {
  data: ArticleResponseDto
  status: 201
}

export type adminArticleControllerPublishResponseSuccess = (adminArticleControllerPublishResponse201) & {
  headers: Headers;
};
;

export type adminArticleControllerPublishResponse = (adminArticleControllerPublishResponseSuccess)

export const getAdminArticleControllerPublishUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/publish`
}

/**
 * @summary 記事公開
 */
export const adminArticleControllerPublish = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerPublishResponse> => {

  return customFetch<adminArticleControllerPublishResponse>(getAdminArticleControllerPublishUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerUnpublishResponse201 = {
  data: ArticleResponseDto
  status: 201
}

export type adminArticleControllerUnpublishResponseSuccess = (adminArticleControllerUnpublishResponse201) & {
  headers: Headers;
};
;

export type adminArticleControllerUnpublishResponse = (adminArticleControllerUnpublishResponseSuccess)

export const getAdminArticleControllerUnpublishUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/unpublish`
}

/**
 * @summary 記事非公開
 */
export const adminArticleControllerUnpublish = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerUnpublishResponse> => {

  return customFetch<adminArticleControllerUnpublishResponse>(getAdminArticleControllerUnpublishUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerSubmitReviewResponse201 = {
  data: ArticleResponseDto
  status: 201
}

export type adminArticleControllerSubmitReviewResponseSuccess = (adminArticleControllerSubmitReviewResponse201) & {
  headers: Headers;
};
;

export type adminArticleControllerSubmitReviewResponse = (adminArticleControllerSubmitReviewResponseSuccess)

export const getAdminArticleControllerSubmitReviewUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/submit-review`
}

/**
 * @summary レビュー依頼
 */
export const adminArticleControllerSubmitReview = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerSubmitReviewResponse> => {

  return customFetch<adminArticleControllerSubmitReviewResponse>(getAdminArticleControllerSubmitReviewUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerApproveResponse201 = {
  data: ArticleResponseDto
  status: 201
}

export type adminArticleControllerApproveResponseSuccess = (adminArticleControllerApproveResponse201) & {
  headers: Headers;
};
;

export type adminArticleControllerApproveResponse = (adminArticleControllerApproveResponseSuccess)

export const getAdminArticleControllerApproveUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/approve`
}

/**
 * @summary 記事承認
 */
export const adminArticleControllerApprove = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerApproveResponse> => {

  return customFetch<adminArticleControllerApproveResponse>(getAdminArticleControllerApproveUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerRejectResponse201 = {
  data: ArticleResponseDto
  status: 201
}

export type adminArticleControllerRejectResponseSuccess = (adminArticleControllerRejectResponse201) & {
  headers: Headers;
};
;

export type adminArticleControllerRejectResponse = (adminArticleControllerRejectResponseSuccess)

export const getAdminArticleControllerRejectUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/reject`
}

/**
 * @summary 記事差し戻し
 */
export const adminArticleControllerReject = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerRejectResponse> => {

  return customFetch<adminArticleControllerRejectResponse>(getAdminArticleControllerRejectUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerCreatePreviewResponse201 = {
  data: PreviewUrlResponseDto
  status: 201
}

export type adminArticleControllerCreatePreviewResponse403 = {
  data: void
  status: 403
}

export type adminArticleControllerCreatePreviewResponseSuccess = (adminArticleControllerCreatePreviewResponse201) & {
  headers: Headers;
};
export type adminArticleControllerCreatePreviewResponseError = (adminArticleControllerCreatePreviewResponse403) & {
  headers: Headers;
};

export type adminArticleControllerCreatePreviewResponse = (adminArticleControllerCreatePreviewResponseSuccess | adminArticleControllerCreatePreviewResponseError)

export const getAdminArticleControllerCreatePreviewUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/preview`
}

/**
 * @summary プレビューURL生成
 */
export const adminArticleControllerCreatePreview = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerCreatePreviewResponse> => {

  return customFetch<adminArticleControllerCreatePreviewResponse>(getAdminArticleControllerCreatePreviewUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerRechunkResponse201 = {
  data: MessageResponseDto
  status: 201
}

export type adminArticleControllerRechunkResponse404 = {
  data: void
  status: 404
}

export type adminArticleControllerRechunkResponseSuccess = (adminArticleControllerRechunkResponse201) & {
  headers: Headers;
};
export type adminArticleControllerRechunkResponseError = (adminArticleControllerRechunkResponse404) & {
  headers: Headers;
};

export type adminArticleControllerRechunkResponse = (adminArticleControllerRechunkResponseSuccess | adminArticleControllerRechunkResponseError)

export const getAdminArticleControllerRechunkUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/articles/${id}/rechunk`
}

/**
 * @summary 記事を手動で再チャンク化
 */
export const adminArticleControllerRechunk = async (productId: string,
    id: string, options?: RequestInit): Promise<adminArticleControllerRechunkResponse> => {

  return customFetch<adminArticleControllerRechunkResponse>(getAdminArticleControllerRechunkUrl(productId,id),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminArticleControllerGenerateDescriptionResponse201 = {
  data: GenerateDescriptionResponseDto
  status: 201
}

export type adminArticleControllerGenerateDescriptionResponse400 = {
  data: void
  status: 400
}

export type adminArticleControllerGenerateDescriptionResponseSuccess = (adminArticleControllerGenerateDescriptionResponse201) & {
  headers: Headers;
};
export type adminArticleControllerGenerateDescriptionResponseError = (adminArticleControllerGenerateDescriptionResponse400) & {
  headers: Headers;
};

export type adminArticleControllerGenerateDescriptionResponse = (adminArticleControllerGenerateDescriptionResponseSuccess | adminArticleControllerGenerateDescriptionResponseError)

export const getAdminArticleControllerGenerateDescriptionUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/articles/generate-description`
}

/**
 * @summary AIによるメタディスクリプション生成
 */
export const adminArticleControllerGenerateDescription = async (productId: string,
    generateDescriptionRequestDto: GenerateDescriptionRequestDto, options?: RequestInit): Promise<adminArticleControllerGenerateDescriptionResponse> => {

  return customFetch<adminArticleControllerGenerateDescriptionResponse>(getAdminArticleControllerGenerateDescriptionUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(generateDescriptionRequestDto)
  }
);}



export type adminCategoryControllerFindAllResponse200 = {
  data: CategoryTreeDto[]
  status: 200
}

export type adminCategoryControllerFindAllResponseSuccess = (adminCategoryControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type adminCategoryControllerFindAllResponse = (adminCategoryControllerFindAllResponseSuccess)

export const getAdminCategoryControllerFindAllUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/categories`
}

/**
 * @summary カテゴリツリー取得
 */
export const adminCategoryControllerFindAll = async (productId: string, options?: RequestInit): Promise<adminCategoryControllerFindAllResponse> => {

  return customFetch<adminCategoryControllerFindAllResponse>(getAdminCategoryControllerFindAllUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminCategoryControllerCreateResponse201 = {
  data: CategoryResponseDto
  status: 201
}

export type adminCategoryControllerCreateResponseSuccess = (adminCategoryControllerCreateResponse201) & {
  headers: Headers;
};
;

export type adminCategoryControllerCreateResponse = (adminCategoryControllerCreateResponseSuccess)

export const getAdminCategoryControllerCreateUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/categories`
}

/**
 * @summary カテゴリ作成
 */
export const adminCategoryControllerCreate = async (productId: string,
    createCategoryDto: CreateCategoryDto, options?: RequestInit): Promise<adminCategoryControllerCreateResponse> => {

  return customFetch<adminCategoryControllerCreateResponse>(getAdminCategoryControllerCreateUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCategoryDto)
  }
);}



export type adminCategoryControllerUpdateResponse200 = {
  data: CategoryResponseDto
  status: 200
}

export type adminCategoryControllerUpdateResponseSuccess = (adminCategoryControllerUpdateResponse200) & {
  headers: Headers;
};
;

export type adminCategoryControllerUpdateResponse = (adminCategoryControllerUpdateResponseSuccess)

export const getAdminCategoryControllerUpdateUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/categories/${id}`
}

/**
 * @summary カテゴリ更新
 */
export const adminCategoryControllerUpdate = async (productId: string,
    id: string,
    updateCategoryDto: UpdateCategoryDto, options?: RequestInit): Promise<adminCategoryControllerUpdateResponse> => {

  return customFetch<adminCategoryControllerUpdateResponse>(getAdminCategoryControllerUpdateUrl(productId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateCategoryDto)
  }
);}



export type adminCategoryControllerRemoveResponse200 = {
  data: CategoryResponseDto
  status: 200
}

export type adminCategoryControllerRemoveResponseSuccess = (adminCategoryControllerRemoveResponse200) & {
  headers: Headers;
};
;

export type adminCategoryControllerRemoveResponse = (adminCategoryControllerRemoveResponseSuccess)

export const getAdminCategoryControllerRemoveUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/categories/${id}`
}

/**
 * @summary カテゴリ削除
 */
export const adminCategoryControllerRemove = async (productId: string,
    id: string, options?: RequestInit): Promise<adminCategoryControllerRemoveResponse> => {

  return customFetch<adminCategoryControllerRemoveResponse>(getAdminCategoryControllerRemoveUrl(productId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminTagControllerFindAllResponse200 = {
  data: TagResponseDto[]
  status: 200
}

export type adminTagControllerFindAllResponseSuccess = (adminTagControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type adminTagControllerFindAllResponse = (adminTagControllerFindAllResponseSuccess)

export const getAdminTagControllerFindAllUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/tags`
}

/**
 * @summary タグ一覧取得
 */
export const adminTagControllerFindAll = async (productId: string, options?: RequestInit): Promise<adminTagControllerFindAllResponse> => {

  return customFetch<adminTagControllerFindAllResponse>(getAdminTagControllerFindAllUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminTagControllerCreateResponse201 = {
  data: TagResponseDto
  status: 201
}

export type adminTagControllerCreateResponseSuccess = (adminTagControllerCreateResponse201) & {
  headers: Headers;
};
;

export type adminTagControllerCreateResponse = (adminTagControllerCreateResponseSuccess)

export const getAdminTagControllerCreateUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/tags`
}

/**
 * @summary タグ作成
 */
export const adminTagControllerCreate = async (productId: string,
    createTagDto: CreateTagDto, options?: RequestInit): Promise<adminTagControllerCreateResponse> => {

  return customFetch<adminTagControllerCreateResponse>(getAdminTagControllerCreateUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTagDto)
  }
);}



export type adminTagControllerRemoveResponse200 = {
  data: TagResponseDto
  status: 200
}

export type adminTagControllerRemoveResponseSuccess = (adminTagControllerRemoveResponse200) & {
  headers: Headers;
};
;

export type adminTagControllerRemoveResponse = (adminTagControllerRemoveResponseSuccess)

export const getAdminTagControllerRemoveUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/tags/${id}`
}

/**
 * @summary タグ削除
 */
export const adminTagControllerRemove = async (productId: string,
    id: string, options?: RequestInit): Promise<adminTagControllerRemoveResponse> => {

  return customFetch<adminTagControllerRemoveResponse>(getAdminTagControllerRemoveUrl(productId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminMediaControllerFindAllResponse200 = {
  data: PaginatedMediaResponseDto
  status: 200
}

export type adminMediaControllerFindAllResponseSuccess = (adminMediaControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type adminMediaControllerFindAllResponse = (adminMediaControllerFindAllResponseSuccess)

export const getAdminMediaControllerFindAllUrl = (productId: string,
    params: AdminMediaControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/media?${stringifiedParams}` : `/api/admin/v1/products/${productId}/media`
}

/**
 * @summary メディア一覧取得
 */
export const adminMediaControllerFindAll = async (productId: string,
    params: AdminMediaControllerFindAllParams, options?: RequestInit): Promise<adminMediaControllerFindAllResponse> => {

  return customFetch<adminMediaControllerFindAllResponse>(getAdminMediaControllerFindAllUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminMediaControllerUploadResponse201 = {
  data: MediaResponseDto
  status: 201
}

export type adminMediaControllerUploadResponseSuccess = (adminMediaControllerUploadResponse201) & {
  headers: Headers;
};
;

export type adminMediaControllerUploadResponse = (adminMediaControllerUploadResponseSuccess)

export const getAdminMediaControllerUploadUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/media`
}

/**
 * @summary メディアアップロード
 */
export const adminMediaControllerUpload = async (productId: string, options?: RequestInit): Promise<adminMediaControllerUploadResponse> => {

  return customFetch<adminMediaControllerUploadResponse>(getAdminMediaControllerUploadUrl(productId),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminMediaControllerDeleteResponse200 = {
  data: MediaMessageResponseDto
  status: 200
}

export type adminMediaControllerDeleteResponseSuccess = (adminMediaControllerDeleteResponse200) & {
  headers: Headers;
};
;

export type adminMediaControllerDeleteResponse = (adminMediaControllerDeleteResponseSuccess)

export const getAdminMediaControllerDeleteUrl = (productId: string,
    id: string,) => {




  return `/api/admin/v1/products/${productId}/media/${id}`
}

/**
 * @summary メディア削除
 */
export const adminMediaControllerDelete = async (productId: string,
    id: string, options?: RequestInit): Promise<adminMediaControllerDeleteResponse> => {

  return customFetch<adminMediaControllerDeleteResponse>(getAdminMediaControllerDeleteUrl(productId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminAnalyticsControllerGetFeedbackSummaryResponse200 = {
  data: FeedbackSummaryDto
  status: 200
}

export type adminAnalyticsControllerGetFeedbackSummaryResponseSuccess = (adminAnalyticsControllerGetFeedbackSummaryResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetFeedbackSummaryResponse = (adminAnalyticsControllerGetFeedbackSummaryResponseSuccess)

export const getAdminAnalyticsControllerGetFeedbackSummaryUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/analytics/feedback/summary`
}

/**
 * @summary フィードバック統計サマリ取得
 */
export const adminAnalyticsControllerGetFeedbackSummary = async (productId: string, options?: RequestInit): Promise<adminAnalyticsControllerGetFeedbackSummaryResponse> => {

  return customFetch<adminAnalyticsControllerGetFeedbackSummaryResponse>(getAdminAnalyticsControllerGetFeedbackSummaryUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerGetFeedbackByArticleResponse200 = {
  data: FeedbackByArticleResponseDto
  status: 200
}

export type adminAnalyticsControllerGetFeedbackByArticleResponseSuccess = (adminAnalyticsControllerGetFeedbackByArticleResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetFeedbackByArticleResponse = (adminAnalyticsControllerGetFeedbackByArticleResponseSuccess)

export const getAdminAnalyticsControllerGetFeedbackByArticleUrl = (productId: string,
    params?: AdminAnalyticsControllerGetFeedbackByArticleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/feedback/by-article?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/feedback/by-article`
}

/**
 * @summary 記事別フィードバック統計取得
 */
export const adminAnalyticsControllerGetFeedbackByArticle = async (productId: string,
    params?: AdminAnalyticsControllerGetFeedbackByArticleParams, options?: RequestInit): Promise<adminAnalyticsControllerGetFeedbackByArticleResponse> => {

  return customFetch<adminAnalyticsControllerGetFeedbackByArticleResponse>(getAdminAnalyticsControllerGetFeedbackByArticleUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerGetFeedbacksWithCommentsResponse200 = {
  data: FeedbackCommentsResponseDto
  status: 200
}

export type adminAnalyticsControllerGetFeedbacksWithCommentsResponseSuccess = (adminAnalyticsControllerGetFeedbacksWithCommentsResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetFeedbacksWithCommentsResponse = (adminAnalyticsControllerGetFeedbacksWithCommentsResponseSuccess)

export const getAdminAnalyticsControllerGetFeedbacksWithCommentsUrl = (productId: string,
    params?: AdminAnalyticsControllerGetFeedbacksWithCommentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/feedback/comments?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/feedback/comments`
}

/**
 * @summary コメント付きフィードバック一覧取得
 */
export const adminAnalyticsControllerGetFeedbacksWithComments = async (productId: string,
    params?: AdminAnalyticsControllerGetFeedbacksWithCommentsParams, options?: RequestInit): Promise<adminAnalyticsControllerGetFeedbacksWithCommentsResponse> => {

  return customFetch<adminAnalyticsControllerGetFeedbacksWithCommentsResponse>(getAdminAnalyticsControllerGetFeedbacksWithCommentsUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerGetSearchKeywordRankingResponse200 = {
  data: SearchKeywordRankingResponseDto
  status: 200
}

export type adminAnalyticsControllerGetSearchKeywordRankingResponseSuccess = (adminAnalyticsControllerGetSearchKeywordRankingResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetSearchKeywordRankingResponse = (adminAnalyticsControllerGetSearchKeywordRankingResponseSuccess)

export const getAdminAnalyticsControllerGetSearchKeywordRankingUrl = (productId: string,
    params?: AdminAnalyticsControllerGetSearchKeywordRankingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/search/keywords?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/search/keywords`
}

/**
 * @summary 検索キーワードランキング取得（Top 50）
 */
export const adminAnalyticsControllerGetSearchKeywordRanking = async (productId: string,
    params?: AdminAnalyticsControllerGetSearchKeywordRankingParams, options?: RequestInit): Promise<adminAnalyticsControllerGetSearchKeywordRankingResponse> => {

  return customFetch<adminAnalyticsControllerGetSearchKeywordRankingResponse>(getAdminAnalyticsControllerGetSearchKeywordRankingUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerGetSearchZeroResultKeywordsResponse200 = {
  data: SearchZeroResultResponseDto
  status: 200
}

export type adminAnalyticsControllerGetSearchZeroResultKeywordsResponseSuccess = (adminAnalyticsControllerGetSearchZeroResultKeywordsResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetSearchZeroResultKeywordsResponse = (adminAnalyticsControllerGetSearchZeroResultKeywordsResponseSuccess)

export const getAdminAnalyticsControllerGetSearchZeroResultKeywordsUrl = (productId: string,
    params?: AdminAnalyticsControllerGetSearchZeroResultKeywordsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/search/zero-results?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/search/zero-results`
}

/**
 * @summary 検索0件キーワード一覧取得
 */
export const adminAnalyticsControllerGetSearchZeroResultKeywords = async (productId: string,
    params?: AdminAnalyticsControllerGetSearchZeroResultKeywordsParams, options?: RequestInit): Promise<adminAnalyticsControllerGetSearchZeroResultKeywordsResponse> => {

  return customFetch<adminAnalyticsControllerGetSearchZeroResultKeywordsResponse>(getAdminAnalyticsControllerGetSearchZeroResultKeywordsUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerGetArticlePerformanceResponse200 = {
  data: ArticlePerformanceResponseDto
  status: 200
}

export type adminAnalyticsControllerGetArticlePerformanceResponseSuccess = (adminAnalyticsControllerGetArticlePerformanceResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetArticlePerformanceResponse = (adminAnalyticsControllerGetArticlePerformanceResponseSuccess)

export const getAdminAnalyticsControllerGetArticlePerformanceUrl = (productId: string,
    params?: AdminAnalyticsControllerGetArticlePerformanceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/articles?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/articles`
}

/**
 * @summary 記事別パフォーマンス一覧取得（PV + フィードバック）
 */
export const adminAnalyticsControllerGetArticlePerformance = async (productId: string,
    params?: AdminAnalyticsControllerGetArticlePerformanceParams, options?: RequestInit): Promise<adminAnalyticsControllerGetArticlePerformanceResponse> => {

  return customFetch<adminAnalyticsControllerGetArticlePerformanceResponse>(getAdminAnalyticsControllerGetArticlePerformanceUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerGetAnalyticsSummaryResponse200 = {
  data: AnalyticsSummaryResponseDto
  status: 200
}

export type adminAnalyticsControllerGetAnalyticsSummaryResponseSuccess = (adminAnalyticsControllerGetAnalyticsSummaryResponse200) & {
  headers: Headers;
};
;

export type adminAnalyticsControllerGetAnalyticsSummaryResponse = (adminAnalyticsControllerGetAnalyticsSummaryResponseSuccess)

export const getAdminAnalyticsControllerGetAnalyticsSummaryUrl = (productId: string,
    params?: AdminAnalyticsControllerGetAnalyticsSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/summary?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/summary`
}

/**
 * @summary 分析概要サマリー取得
 */
export const adminAnalyticsControllerGetAnalyticsSummary = async (productId: string,
    params?: AdminAnalyticsControllerGetAnalyticsSummaryParams, options?: RequestInit): Promise<adminAnalyticsControllerGetAnalyticsSummaryResponse> => {

  return customFetch<adminAnalyticsControllerGetAnalyticsSummaryResponse>(getAdminAnalyticsControllerGetAnalyticsSummaryUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerExportArticlesCsvResponseDefault = {
  data: unknown
  status: number
}

;
export type adminAnalyticsControllerExportArticlesCsvResponseError = (adminAnalyticsControllerExportArticlesCsvResponseDefault) & {
  headers: Headers;
};

export type adminAnalyticsControllerExportArticlesCsvResponse = (adminAnalyticsControllerExportArticlesCsvResponseError)

export const getAdminAnalyticsControllerExportArticlesCsvUrl = (productId: string,
    params?: AdminAnalyticsControllerExportArticlesCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/export/articles?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/export/articles`
}

/**
 * @summary 記事パフォーマンス CSV エクスポート
 */
export const adminAnalyticsControllerExportArticlesCsv = async (productId: string,
    params?: AdminAnalyticsControllerExportArticlesCsvParams, options?: RequestInit): Promise<adminAnalyticsControllerExportArticlesCsvResponse> => {

  return customFetch<adminAnalyticsControllerExportArticlesCsvResponse>(getAdminAnalyticsControllerExportArticlesCsvUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAnalyticsControllerExportSearchCsvResponseDefault = {
  data: unknown
  status: number
}

;
export type adminAnalyticsControllerExportSearchCsvResponseError = (adminAnalyticsControllerExportSearchCsvResponseDefault) & {
  headers: Headers;
};

export type adminAnalyticsControllerExportSearchCsvResponse = (adminAnalyticsControllerExportSearchCsvResponseError)

export const getAdminAnalyticsControllerExportSearchCsvUrl = (productId: string,
    params?: AdminAnalyticsControllerExportSearchCsvParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/products/${productId}/analytics/export/search?${stringifiedParams}` : `/api/admin/v1/products/${productId}/analytics/export/search`
}

/**
 * @summary 検索キーワード CSV エクスポート
 */
export const adminAnalyticsControllerExportSearchCsv = async (productId: string,
    params?: AdminAnalyticsControllerExportSearchCsvParams, options?: RequestInit): Promise<adminAnalyticsControllerExportSearchCsvResponse> => {

  return customFetch<adminAnalyticsControllerExportSearchCsvResponse>(getAdminAnalyticsControllerExportSearchCsvUrl(productId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminMemberControllerFindAllResponse200 = {
  data: PaginatedMemberResponseDto
  status: 200
}

export type adminMemberControllerFindAllResponseSuccess = (adminMemberControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type adminMemberControllerFindAllResponse = (adminMemberControllerFindAllResponseSuccess)

export const getAdminMemberControllerFindAllUrl = (params?: AdminMemberControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/members?${stringifiedParams}` : `/api/admin/v1/members`
}

/**
 * @summary 組織メンバー一覧取得
 */
export const adminMemberControllerFindAll = async (params?: AdminMemberControllerFindAllParams, options?: RequestInit): Promise<adminMemberControllerFindAllResponse> => {

  return customFetch<adminMemberControllerFindAllResponse>(getAdminMemberControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminMemberControllerUpdateResponse200 = {
  data: MemberResponseDto
  status: 200
}

export type adminMemberControllerUpdateResponseSuccess = (adminMemberControllerUpdateResponse200) & {
  headers: Headers;
};
;

export type adminMemberControllerUpdateResponse = (adminMemberControllerUpdateResponseSuccess)

export const getAdminMemberControllerUpdateUrl = (id: string,) => {




  return `/api/admin/v1/members/${id}`
}

/**
 * @summary メンバーロール変更
 */
export const adminMemberControllerUpdate = async (id: string,
    updateMemberDto: UpdateMemberDto, options?: RequestInit): Promise<adminMemberControllerUpdateResponse> => {

  return customFetch<adminMemberControllerUpdateResponse>(getAdminMemberControllerUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMemberDto)
  }
);}



export type adminMemberControllerRemoveResponse204 = {
  data: void
  status: 204
}

export type adminMemberControllerRemoveResponseSuccess = (adminMemberControllerRemoveResponse204) & {
  headers: Headers;
};
;

export type adminMemberControllerRemoveResponse = (adminMemberControllerRemoveResponseSuccess)

export const getAdminMemberControllerRemoveUrl = (id: string,) => {




  return `/api/admin/v1/members/${id}`
}

/**
 * @summary メンバー除外
 */
export const adminMemberControllerRemove = async (id: string, options?: RequestInit): Promise<adminMemberControllerRemoveResponse> => {

  return customFetch<adminMemberControllerRemoveResponse>(getAdminMemberControllerRemoveUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminPermissionControllerFindByProductResponse200 = {
  data: PermissionResponseDto[]
  status: 200
}

export type adminPermissionControllerFindByProductResponseSuccess = (adminPermissionControllerFindByProductResponse200) & {
  headers: Headers;
};
;

export type adminPermissionControllerFindByProductResponse = (adminPermissionControllerFindByProductResponseSuccess)

export const getAdminPermissionControllerFindByProductUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/permissions`
}

/**
 * @summary プロダクトのユーザー権限一覧取得
 */
export const adminPermissionControllerFindByProduct = async (productId: string, options?: RequestInit): Promise<adminPermissionControllerFindByProductResponse> => {

  return customFetch<adminPermissionControllerFindByProductResponse>(getAdminPermissionControllerFindByProductUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminPermissionControllerSetPermissionResponse200 = {
  data: PermissionResponseDto
  status: 200
}

export type adminPermissionControllerSetPermissionResponseSuccess = (adminPermissionControllerSetPermissionResponse200) & {
  headers: Headers;
};
;

export type adminPermissionControllerSetPermissionResponse = (adminPermissionControllerSetPermissionResponseSuccess)

export const getAdminPermissionControllerSetPermissionUrl = (productId: string,
    userId: string,) => {




  return `/api/admin/v1/products/${productId}/permissions/${userId}`
}

/**
 * @summary ユーザーのプロダクト権限設定
 */
export const adminPermissionControllerSetPermission = async (productId: string,
    userId: string,
    setPermissionDto: SetPermissionDto, options?: RequestInit): Promise<adminPermissionControllerSetPermissionResponse> => {

  return customFetch<adminPermissionControllerSetPermissionResponse>(getAdminPermissionControllerSetPermissionUrl(productId,userId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setPermissionDto)
  }
);}



export type adminMeControllerFindMyProductsResponse200 = {
  data: OrganizationProductGroupDto[]
  status: 200
}

export type adminMeControllerFindMyProductsResponseSuccess = (adminMeControllerFindMyProductsResponse200) & {
  headers: Headers;
};
;

export type adminMeControllerFindMyProductsResponse = (adminMeControllerFindMyProductsResponseSuccess)

export const getAdminMeControllerFindMyProductsUrl = () => {




  return `/api/admin/v1/me/products`
}

/**
 * @summary ユーザーが権限を持つプロダクト一覧（組織横断）
 */
export const adminMeControllerFindMyProducts = async ( options?: RequestInit): Promise<adminMeControllerFindMyProductsResponse> => {

  return customFetch<adminMeControllerFindMyProductsResponse>(getAdminMeControllerFindMyProductsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminProductDomainControllerSetCustomDomainResponse200 = {
  data: CustomDomainResponseDto
  status: 200
}

export type adminProductDomainControllerSetCustomDomainResponse400 = {
  data: void
  status: 400
}

export type adminProductDomainControllerSetCustomDomainResponse409 = {
  data: void
  status: 409
}

export type adminProductDomainControllerSetCustomDomainResponseSuccess = (adminProductDomainControllerSetCustomDomainResponse200) & {
  headers: Headers;
};
export type adminProductDomainControllerSetCustomDomainResponseError = (adminProductDomainControllerSetCustomDomainResponse400 | adminProductDomainControllerSetCustomDomainResponse409) & {
  headers: Headers;
};

export type adminProductDomainControllerSetCustomDomainResponse = (adminProductDomainControllerSetCustomDomainResponseSuccess | adminProductDomainControllerSetCustomDomainResponseError)

export const getAdminProductDomainControllerSetCustomDomainUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/custom-domain`
}

/**
 * @summary カスタムドメイン設定
 */
export const adminProductDomainControllerSetCustomDomain = async (productId: string,
    setCustomDomainDto: SetCustomDomainDto, options?: RequestInit): Promise<adminProductDomainControllerSetCustomDomainResponse> => {

  return customFetch<adminProductDomainControllerSetCustomDomainResponse>(getAdminProductDomainControllerSetCustomDomainUrl(productId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setCustomDomainDto)
  }
);}



export type adminProductDomainControllerRemoveCustomDomainResponse200 = {
  data: CustomDomainResponseDto
  status: 200
}

export type adminProductDomainControllerRemoveCustomDomainResponseSuccess = (adminProductDomainControllerRemoveCustomDomainResponse200) & {
  headers: Headers;
};
;

export type adminProductDomainControllerRemoveCustomDomainResponse = (adminProductDomainControllerRemoveCustomDomainResponseSuccess)

export const getAdminProductDomainControllerRemoveCustomDomainUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/custom-domain`
}

/**
 * @summary カスタムドメイン削除
 */
export const adminProductDomainControllerRemoveCustomDomain = async (productId: string, options?: RequestInit): Promise<adminProductDomainControllerRemoveCustomDomainResponse> => {

  return customFetch<adminProductDomainControllerRemoveCustomDomainResponse>(getAdminProductDomainControllerRemoveCustomDomainUrl(productId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminProductDomainControllerVerifyCustomDomainResponse200 = {
  data: CustomDomainResponseDto
  status: 200
}

export type adminProductDomainControllerVerifyCustomDomainResponse400 = {
  data: void
  status: 400
}

export type adminProductDomainControllerVerifyCustomDomainResponseSuccess = (adminProductDomainControllerVerifyCustomDomainResponse200) & {
  headers: Headers;
};
export type adminProductDomainControllerVerifyCustomDomainResponseError = (adminProductDomainControllerVerifyCustomDomainResponse400) & {
  headers: Headers;
};

export type adminProductDomainControllerVerifyCustomDomainResponse = (adminProductDomainControllerVerifyCustomDomainResponseSuccess | adminProductDomainControllerVerifyCustomDomainResponseError)

export const getAdminProductDomainControllerVerifyCustomDomainUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/custom-domain/verify`
}

/**
 * @summary カスタムドメインDNS検証
 */
export const adminProductDomainControllerVerifyCustomDomain = async (productId: string, options?: RequestInit): Promise<adminProductDomainControllerVerifyCustomDomainResponse> => {

  return customFetch<adminProductDomainControllerVerifyCustomDomainResponse>(getAdminProductDomainControllerVerifyCustomDomainUrl(productId),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminProductDomainControllerReactivateCustomDomainResponse200 = {
  data: CustomDomainResponseDto
  status: 200
}

export type adminProductDomainControllerReactivateCustomDomainResponse400 = {
  data: void
  status: 400
}

export type adminProductDomainControllerReactivateCustomDomainResponse402 = {
  data: void
  status: 402
}

export type adminProductDomainControllerReactivateCustomDomainResponseSuccess = (adminProductDomainControllerReactivateCustomDomainResponse200) & {
  headers: Headers;
};
export type adminProductDomainControllerReactivateCustomDomainResponseError = (adminProductDomainControllerReactivateCustomDomainResponse400 | adminProductDomainControllerReactivateCustomDomainResponse402) & {
  headers: Headers;
};

export type adminProductDomainControllerReactivateCustomDomainResponse = (adminProductDomainControllerReactivateCustomDomainResponseSuccess | adminProductDomainControllerReactivateCustomDomainResponseError)

export const getAdminProductDomainControllerReactivateCustomDomainUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/custom-domain/reactivate`
}

/**
 * @summary カスタムドメイン再有効化（SUSPENDED → PENDING_VERIFICATION）
 */
export const adminProductDomainControllerReactivateCustomDomain = async (productId: string, options?: RequestInit): Promise<adminProductDomainControllerReactivateCustomDomainResponse> => {

  return customFetch<adminProductDomainControllerReactivateCustomDomainResponse>(getAdminProductDomainControllerReactivateCustomDomainUrl(productId),
  {
    ...options,
    method: 'POST'


  }
);}



export type providerOrganizationControllerFindAllResponse200 = {
  data: PaginatedOrganizationResponseDto
  status: 200
}

export type providerOrganizationControllerFindAllResponseSuccess = (providerOrganizationControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type providerOrganizationControllerFindAllResponse = (providerOrganizationControllerFindAllResponseSuccess)

export const getProviderOrganizationControllerFindAllUrl = (params?: ProviderOrganizationControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/organizations?${stringifiedParams}` : `/api/provider/v1/organizations`
}

/**
 * @summary 全組織一覧取得
 */
export const providerOrganizationControllerFindAll = async (params?: ProviderOrganizationControllerFindAllParams, options?: RequestInit): Promise<providerOrganizationControllerFindAllResponse> => {

  return customFetch<providerOrganizationControllerFindAllResponse>(getProviderOrganizationControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerOrganizationControllerFindByIdResponse200 = {
  data: OrganizationResponseDto
  status: 200
}

export type providerOrganizationControllerFindByIdResponse404 = {
  data: void
  status: 404
}

export type providerOrganizationControllerFindByIdResponseSuccess = (providerOrganizationControllerFindByIdResponse200) & {
  headers: Headers;
};
export type providerOrganizationControllerFindByIdResponseError = (providerOrganizationControllerFindByIdResponse404) & {
  headers: Headers;
};

export type providerOrganizationControllerFindByIdResponse = (providerOrganizationControllerFindByIdResponseSuccess | providerOrganizationControllerFindByIdResponseError)

export const getProviderOrganizationControllerFindByIdUrl = (id: string,) => {




  return `/api/provider/v1/organizations/${id}`
}

/**
 * @summary 組織詳細取得
 */
export const providerOrganizationControllerFindById = async (id: string, options?: RequestInit): Promise<providerOrganizationControllerFindByIdResponse> => {

  return customFetch<providerOrganizationControllerFindByIdResponse>(getProviderOrganizationControllerFindByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerOrganizationControllerUpdateResponse200 = {
  data: OrganizationResponseDto
  status: 200
}

export type providerOrganizationControllerUpdateResponse403 = {
  data: void
  status: 403
}

export type providerOrganizationControllerUpdateResponseSuccess = (providerOrganizationControllerUpdateResponse200) & {
  headers: Headers;
};
export type providerOrganizationControllerUpdateResponseError = (providerOrganizationControllerUpdateResponse403) & {
  headers: Headers;
};

export type providerOrganizationControllerUpdateResponse = (providerOrganizationControllerUpdateResponseSuccess | providerOrganizationControllerUpdateResponseError)

export const getProviderOrganizationControllerUpdateUrl = (id: string,) => {




  return `/api/provider/v1/organizations/${id}`
}

/**
 * @summary 組織更新
 */
export const providerOrganizationControllerUpdate = async (id: string,
    updateOrganizationDto: UpdateOrganizationDto, options?: RequestInit): Promise<providerOrganizationControllerUpdateResponse> => {

  return customFetch<providerOrganizationControllerUpdateResponse>(getProviderOrganizationControllerUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrganizationDto)
  }
);}



export type providerOrganizationControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type providerOrganizationControllerDeleteResponse403 = {
  data: void
  status: 403
}

export type providerOrganizationControllerDeleteResponseSuccess = (providerOrganizationControllerDeleteResponse204) & {
  headers: Headers;
};
export type providerOrganizationControllerDeleteResponseError = (providerOrganizationControllerDeleteResponse403) & {
  headers: Headers;
};

export type providerOrganizationControllerDeleteResponse = (providerOrganizationControllerDeleteResponseSuccess | providerOrganizationControllerDeleteResponseError)

export const getProviderOrganizationControllerDeleteUrl = (id: string,) => {




  return `/api/provider/v1/organizations/${id}`
}

/**
 * @summary 組織削除
 */
export const providerOrganizationControllerDelete = async (id: string, options?: RequestInit): Promise<providerOrganizationControllerDeleteResponse> => {

  return customFetch<providerOrganizationControllerDeleteResponse>(getProviderOrganizationControllerDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type providerOrgUserControllerFindAllResponse200 = {
  data: PaginatedOrgUserResponseDto
  status: 200
}

export type providerOrgUserControllerFindAllResponseSuccess = (providerOrgUserControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type providerOrgUserControllerFindAllResponse = (providerOrgUserControllerFindAllResponseSuccess)

export const getProviderOrgUserControllerFindAllUrl = (orgId: string,
    params?: ProviderOrgUserControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/organizations/${orgId}/users?${stringifiedParams}` : `/api/provider/v1/organizations/${orgId}/users`
}

/**
 * @summary 組織内テナントユーザー一覧
 */
export const providerOrgUserControllerFindAll = async (orgId: string,
    params?: ProviderOrgUserControllerFindAllParams, options?: RequestInit): Promise<providerOrgUserControllerFindAllResponse> => {

  return customFetch<providerOrgUserControllerFindAllResponse>(getProviderOrgUserControllerFindAllUrl(orgId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerOrgUserControllerUpdateResponse200 = {
  data: OrgUserResponseDto
  status: 200
}

export type providerOrgUserControllerUpdateResponse403 = {
  data: void
  status: 403
}

export type providerOrgUserControllerUpdateResponseSuccess = (providerOrgUserControllerUpdateResponse200) & {
  headers: Headers;
};
export type providerOrgUserControllerUpdateResponseError = (providerOrgUserControllerUpdateResponse403) & {
  headers: Headers;
};

export type providerOrgUserControllerUpdateResponse = (providerOrgUserControllerUpdateResponseSuccess | providerOrgUserControllerUpdateResponseError)

export const getProviderOrgUserControllerUpdateUrl = (orgId: string,
    id: string,) => {




  return `/api/provider/v1/organizations/${orgId}/users/${id}`
}

/**
 * @summary 組織内ユーザー更新
 */
export const providerOrgUserControllerUpdate = async (orgId: string,
    id: string,
    updateOrgUserDto: UpdateOrgUserDto, options?: RequestInit): Promise<providerOrgUserControllerUpdateResponse> => {

  return customFetch<providerOrgUserControllerUpdateResponse>(getProviderOrgUserControllerUpdateUrl(orgId,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateOrgUserDto)
  }
);}



export type providerOrgUserControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type providerOrgUserControllerDeleteResponse403 = {
  data: void
  status: 403
}

export type providerOrgUserControllerDeleteResponseSuccess = (providerOrgUserControllerDeleteResponse204) & {
  headers: Headers;
};
export type providerOrgUserControllerDeleteResponseError = (providerOrgUserControllerDeleteResponse403) & {
  headers: Headers;
};

export type providerOrgUserControllerDeleteResponse = (providerOrgUserControllerDeleteResponseSuccess | providerOrgUserControllerDeleteResponseError)

export const getProviderOrgUserControllerDeleteUrl = (orgId: string,
    id: string,) => {




  return `/api/provider/v1/organizations/${orgId}/users/${id}`
}

/**
 * @summary 組織からユーザーを削除
 */
export const providerOrgUserControllerDelete = async (orgId: string,
    id: string, options?: RequestInit): Promise<providerOrgUserControllerDeleteResponse> => {

  return customFetch<providerOrgUserControllerDeleteResponse>(getProviderOrgUserControllerDeleteUrl(orgId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type providerSystemControllerGetStatsResponse200 = {
  data: SystemStatsResponseDto
  status: 200
}

export type providerSystemControllerGetStatsResponseSuccess = (providerSystemControllerGetStatsResponse200) & {
  headers: Headers;
};
;

export type providerSystemControllerGetStatsResponse = (providerSystemControllerGetStatsResponseSuccess)

export const getProviderSystemControllerGetStatsUrl = () => {




  return `/api/provider/v1/system/stats`
}

/**
 * @summary プラットフォーム統計
 */
export const providerSystemControllerGetStats = async ( options?: RequestInit): Promise<providerSystemControllerGetStatsResponse> => {

  return customFetch<providerSystemControllerGetStatsResponse>(getProviderSystemControllerGetStatsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerAuthControllerLoginResponse200 = {
  data: AuthResponseDto
  status: 200
}

export type providerAuthControllerLoginResponse401 = {
  data: void
  status: 401
}

export type providerAuthControllerLoginResponseSuccess = (providerAuthControllerLoginResponse200) & {
  headers: Headers;
};
export type providerAuthControllerLoginResponseError = (providerAuthControllerLoginResponse401) & {
  headers: Headers;
};

export type providerAuthControllerLoginResponse = (providerAuthControllerLoginResponseSuccess | providerAuthControllerLoginResponseError)

export const getProviderAuthControllerLoginUrl = () => {




  return `/api/provider/v1/auth/login`
}

/**
 * @summary Provider ログイン
 */
export const providerAuthControllerLogin = async (loginDto: LoginDto, options?: RequestInit): Promise<providerAuthControllerLoginResponse> => {

  return customFetch<providerAuthControllerLoginResponse>(getProviderAuthControllerLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginDto)
  }
);}



export type providerAuthControllerRefreshResponse200 = {
  data: AuthResponseDto
  status: 200
}

export type providerAuthControllerRefreshResponse401 = {
  data: void
  status: 401
}

export type providerAuthControllerRefreshResponseSuccess = (providerAuthControllerRefreshResponse200) & {
  headers: Headers;
};
export type providerAuthControllerRefreshResponseError = (providerAuthControllerRefreshResponse401) & {
  headers: Headers;
};

export type providerAuthControllerRefreshResponse = (providerAuthControllerRefreshResponseSuccess | providerAuthControllerRefreshResponseError)

export const getProviderAuthControllerRefreshUrl = () => {




  return `/api/provider/v1/auth/refresh`
}

/**
 * @summary トークンリフレッシュ
 */
export const providerAuthControllerRefresh = async ( options?: RequestInit): Promise<providerAuthControllerRefreshResponse> => {

  return customFetch<providerAuthControllerRefreshResponse>(getProviderAuthControllerRefreshUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type providerAuthControllerLogoutResponse204 = {
  data: void
  status: 204
}

export type providerAuthControllerLogoutResponseSuccess = (providerAuthControllerLogoutResponse204) & {
  headers: Headers;
};
;

export type providerAuthControllerLogoutResponse = (providerAuthControllerLogoutResponseSuccess)

export const getProviderAuthControllerLogoutUrl = () => {




  return `/api/provider/v1/auth/logout`
}

/**
 * @summary ログアウト
 */
export const providerAuthControllerLogout = async ( options?: RequestInit): Promise<providerAuthControllerLogoutResponse> => {

  return customFetch<providerAuthControllerLogoutResponse>(getProviderAuthControllerLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type providerAuthControllerForgotPasswordResponse204 = {
  data: void
  status: 204
}

export type providerAuthControllerForgotPasswordResponseSuccess = (providerAuthControllerForgotPasswordResponse204) & {
  headers: Headers;
};
;

export type providerAuthControllerForgotPasswordResponse = (providerAuthControllerForgotPasswordResponseSuccess)

export const getProviderAuthControllerForgotPasswordUrl = () => {




  return `/api/provider/v1/auth/forgot-password`
}

/**
 * @summary パスワードリセット申請
 */
export const providerAuthControllerForgotPassword = async (forgotPasswordDto: ForgotPasswordDto, options?: RequestInit): Promise<providerAuthControllerForgotPasswordResponse> => {

  return customFetch<providerAuthControllerForgotPasswordResponse>(getProviderAuthControllerForgotPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(forgotPasswordDto)
  }
);}



export type providerAuthControllerVerifyResetTokenResponse200 = {
  data: void
  status: 200
}

export type providerAuthControllerVerifyResetTokenResponse400 = {
  data: void
  status: 400
}

export type providerAuthControllerVerifyResetTokenResponseSuccess = (providerAuthControllerVerifyResetTokenResponse200) & {
  headers: Headers;
};
export type providerAuthControllerVerifyResetTokenResponseError = (providerAuthControllerVerifyResetTokenResponse400) & {
  headers: Headers;
};

export type providerAuthControllerVerifyResetTokenResponse = (providerAuthControllerVerifyResetTokenResponseSuccess | providerAuthControllerVerifyResetTokenResponseError)

export const getProviderAuthControllerVerifyResetTokenUrl = (params: ProviderAuthControllerVerifyResetTokenParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/auth/reset-password/verify?${stringifiedParams}` : `/api/provider/v1/auth/reset-password/verify`
}

/**
 * @summary パスワードリセットトークン検証
 */
export const providerAuthControllerVerifyResetToken = async (params: ProviderAuthControllerVerifyResetTokenParams, options?: RequestInit): Promise<providerAuthControllerVerifyResetTokenResponse> => {

  return customFetch<providerAuthControllerVerifyResetTokenResponse>(getProviderAuthControllerVerifyResetTokenUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerAuthControllerResetPasswordResponse204 = {
  data: void
  status: 204
}

export type providerAuthControllerResetPasswordResponse400 = {
  data: void
  status: 400
}

export type providerAuthControllerResetPasswordResponseSuccess = (providerAuthControllerResetPasswordResponse204) & {
  headers: Headers;
};
export type providerAuthControllerResetPasswordResponseError = (providerAuthControllerResetPasswordResponse400) & {
  headers: Headers;
};

export type providerAuthControllerResetPasswordResponse = (providerAuthControllerResetPasswordResponseSuccess | providerAuthControllerResetPasswordResponseError)

export const getProviderAuthControllerResetPasswordUrl = () => {




  return `/api/provider/v1/auth/reset-password`
}

/**
 * @summary パスワードリセット実行
 */
export const providerAuthControllerResetPassword = async (resetPasswordDto: ResetPasswordDto, options?: RequestInit): Promise<providerAuthControllerResetPasswordResponse> => {

  return customFetch<providerAuthControllerResetPasswordResponse>(getProviderAuthControllerResetPasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(resetPasswordDto)
  }
);}



export type providerUserControllerFindAllResponse200 = {
  data: PaginatedProviderUserResponseDto
  status: 200
}

export type providerUserControllerFindAllResponseSuccess = (providerUserControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type providerUserControllerFindAllResponse = (providerUserControllerFindAllResponseSuccess)

export const getProviderUserControllerFindAllUrl = (params?: ProviderUserControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/provider-users?${stringifiedParams}` : `/api/provider/v1/provider-users`
}

/**
 * @summary Provider ユーザー一覧
 */
export const providerUserControllerFindAll = async (params?: ProviderUserControllerFindAllParams, options?: RequestInit): Promise<providerUserControllerFindAllResponse> => {

  return customFetch<providerUserControllerFindAllResponse>(getProviderUserControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerUserControllerCreateResponse201 = {
  data: ProviderUserResponseDto
  status: 201
}

export type providerUserControllerCreateResponse403 = {
  data: void
  status: 403
}

export type providerUserControllerCreateResponse409 = {
  data: void
  status: 409
}

export type providerUserControllerCreateResponseSuccess = (providerUserControllerCreateResponse201) & {
  headers: Headers;
};
export type providerUserControllerCreateResponseError = (providerUserControllerCreateResponse403 | providerUserControllerCreateResponse409) & {
  headers: Headers;
};

export type providerUserControllerCreateResponse = (providerUserControllerCreateResponseSuccess | providerUserControllerCreateResponseError)

export const getProviderUserControllerCreateUrl = () => {




  return `/api/provider/v1/provider-users`
}

/**
 * @summary Provider ユーザー作成（SUPER_ADMIN のみ）
 */
export const providerUserControllerCreate = async (createProviderUserDto: CreateProviderUserDto, options?: RequestInit): Promise<providerUserControllerCreateResponse> => {

  return customFetch<providerUserControllerCreateResponse>(getProviderUserControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProviderUserDto)
  }
);}



export type providerUserControllerUpdateResponse200 = {
  data: ProviderUserResponseDto
  status: 200
}

export type providerUserControllerUpdateResponse403 = {
  data: void
  status: 403
}

export type providerUserControllerUpdateResponse404 = {
  data: void
  status: 404
}

export type providerUserControllerUpdateResponseSuccess = (providerUserControllerUpdateResponse200) & {
  headers: Headers;
};
export type providerUserControllerUpdateResponseError = (providerUserControllerUpdateResponse403 | providerUserControllerUpdateResponse404) & {
  headers: Headers;
};

export type providerUserControllerUpdateResponse = (providerUserControllerUpdateResponseSuccess | providerUserControllerUpdateResponseError)

export const getProviderUserControllerUpdateUrl = (id: string,) => {




  return `/api/provider/v1/provider-users/${id}`
}

/**
 * @summary Provider ユーザー更新（SUPER_ADMIN のみ）
 */
export const providerUserControllerUpdate = async (id: string,
    updateProviderUserDto: UpdateProviderUserDto, options?: RequestInit): Promise<providerUserControllerUpdateResponse> => {

  return customFetch<providerUserControllerUpdateResponse>(getProviderUserControllerUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProviderUserDto)
  }
);}



export type providerUserControllerDeleteResponse200 = {
  data: ProviderUserMessageResponseDto
  status: 200
}

export type providerUserControllerDeleteResponse400 = {
  data: void
  status: 400
}

export type providerUserControllerDeleteResponse403 = {
  data: void
  status: 403
}

export type providerUserControllerDeleteResponse404 = {
  data: void
  status: 404
}

export type providerUserControllerDeleteResponseSuccess = (providerUserControllerDeleteResponse200) & {
  headers: Headers;
};
export type providerUserControllerDeleteResponseError = (providerUserControllerDeleteResponse400 | providerUserControllerDeleteResponse403 | providerUserControllerDeleteResponse404) & {
  headers: Headers;
};

export type providerUserControllerDeleteResponse = (providerUserControllerDeleteResponseSuccess | providerUserControllerDeleteResponseError)

export const getProviderUserControllerDeleteUrl = (id: string,) => {




  return `/api/provider/v1/provider-users/${id}`
}

/**
 * @summary Provider ユーザー削除（SUPER_ADMIN のみ）
 */
export const providerUserControllerDelete = async (id: string, options?: RequestInit): Promise<providerUserControllerDeleteResponse> => {

  return customFetch<providerUserControllerDeleteResponse>(getProviderUserControllerDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminAccountControllerGetProfileResponse200 = {
  data: ProfileResponseDto
  status: 200
}

export type adminAccountControllerGetProfileResponseSuccess = (adminAccountControllerGetProfileResponse200) & {
  headers: Headers;
};
;

export type adminAccountControllerGetProfileResponse = (adminAccountControllerGetProfileResponseSuccess)

export const getAdminAccountControllerGetProfileUrl = () => {




  return `/api/admin/v1/me`
}

/**
 * @summary プロフィール取得
 */
export const adminAccountControllerGetProfile = async ( options?: RequestInit): Promise<adminAccountControllerGetProfileResponse> => {

  return customFetch<adminAccountControllerGetProfileResponse>(getAdminAccountControllerGetProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminAccountControllerUpdateProfileResponse200 = {
  data: ProfileResponseDto
  status: 200
}

export type adminAccountControllerUpdateProfileResponseSuccess = (adminAccountControllerUpdateProfileResponse200) & {
  headers: Headers;
};
;

export type adminAccountControllerUpdateProfileResponse = (adminAccountControllerUpdateProfileResponseSuccess)

export const getAdminAccountControllerUpdateProfileUrl = () => {




  return `/api/admin/v1/me`
}

/**
 * @summary プロフィール更新（名前）
 */
export const adminAccountControllerUpdateProfile = async (updateProfileDto: UpdateProfileDto, options?: RequestInit): Promise<adminAccountControllerUpdateProfileResponse> => {

  return customFetch<adminAccountControllerUpdateProfileResponse>(getAdminAccountControllerUpdateProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfileDto)
  }
);}



export type adminAccountControllerDeleteAccountResponse204 = {
  data: void
  status: 204
}

export type adminAccountControllerDeleteAccountResponse409 = {
  data: void
  status: 409
}

export type adminAccountControllerDeleteAccountResponseSuccess = (adminAccountControllerDeleteAccountResponse204) & {
  headers: Headers;
};
export type adminAccountControllerDeleteAccountResponseError = (adminAccountControllerDeleteAccountResponse409) & {
  headers: Headers;
};

export type adminAccountControllerDeleteAccountResponse = (adminAccountControllerDeleteAccountResponseSuccess | adminAccountControllerDeleteAccountResponseError)

export const getAdminAccountControllerDeleteAccountUrl = () => {




  return `/api/admin/v1/me`
}

/**
 * @summary アカウント削除
 */
export const adminAccountControllerDeleteAccount = async ( options?: RequestInit): Promise<adminAccountControllerDeleteAccountResponse> => {

  return customFetch<adminAccountControllerDeleteAccountResponse>(getAdminAccountControllerDeleteAccountUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminAccountControllerChangeEmailResponse200 = {
  data: void
  status: 200
}

export type adminAccountControllerChangeEmailResponse401 = {
  data: void
  status: 401
}

export type adminAccountControllerChangeEmailResponse409 = {
  data: void
  status: 409
}

export type adminAccountControllerChangeEmailResponseSuccess = (adminAccountControllerChangeEmailResponse200) & {
  headers: Headers;
};
export type adminAccountControllerChangeEmailResponseError = (adminAccountControllerChangeEmailResponse401 | adminAccountControllerChangeEmailResponse409) & {
  headers: Headers;
};

export type adminAccountControllerChangeEmailResponse = (adminAccountControllerChangeEmailResponseSuccess | adminAccountControllerChangeEmailResponseError)

export const getAdminAccountControllerChangeEmailUrl = () => {




  return `/api/admin/v1/me/change-email`
}

/**
 * @summary メールアドレス変更申請
 */
export const adminAccountControllerChangeEmail = async (changeEmailDto: ChangeEmailDto, options?: RequestInit): Promise<adminAccountControllerChangeEmailResponse> => {

  return customFetch<adminAccountControllerChangeEmailResponse>(getAdminAccountControllerChangeEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeEmailDto)
  }
);}



export type adminAccountControllerVerifyEmailResponse200 = {
  data: void
  status: 200
}

export type adminAccountControllerVerifyEmailResponse400 = {
  data: void
  status: 400
}

export type adminAccountControllerVerifyEmailResponseSuccess = (adminAccountControllerVerifyEmailResponse200) & {
  headers: Headers;
};
export type adminAccountControllerVerifyEmailResponseError = (adminAccountControllerVerifyEmailResponse400) & {
  headers: Headers;
};

export type adminAccountControllerVerifyEmailResponse = (adminAccountControllerVerifyEmailResponseSuccess | adminAccountControllerVerifyEmailResponseError)

export const getAdminAccountControllerVerifyEmailUrl = () => {




  return `/api/admin/v1/me/verify-email`
}

/**
 * @summary メールアドレス変更確認
 */
export const adminAccountControllerVerifyEmail = async (verifyEmailDto: VerifyEmailDto, options?: RequestInit): Promise<adminAccountControllerVerifyEmailResponse> => {

  return customFetch<adminAccountControllerVerifyEmailResponse>(getAdminAccountControllerVerifyEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyEmailDto)
  }
);}



export type adminAccountControllerChangePasswordResponse200 = {
  data: void
  status: 200
}

export type adminAccountControllerChangePasswordResponse401 = {
  data: void
  status: 401
}

export type adminAccountControllerChangePasswordResponseSuccess = (adminAccountControllerChangePasswordResponse200) & {
  headers: Headers;
};
export type adminAccountControllerChangePasswordResponseError = (adminAccountControllerChangePasswordResponse401) & {
  headers: Headers;
};

export type adminAccountControllerChangePasswordResponse = (adminAccountControllerChangePasswordResponseSuccess | adminAccountControllerChangePasswordResponseError)

export const getAdminAccountControllerChangePasswordUrl = () => {




  return `/api/admin/v1/me/change-password`
}

/**
 * @summary パスワード変更
 */
export const adminAccountControllerChangePassword = async (changePasswordDto: ChangePasswordDto, options?: RequestInit): Promise<adminAccountControllerChangePasswordResponse> => {

  return customFetch<adminAccountControllerChangePasswordResponse>(getAdminAccountControllerChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePasswordDto)
  }
);}



export type adminAccountControllerGetDeletionEligibilityResponse200 = {
  data: DeletionEligibilityResponseDto
  status: 200
}

export type adminAccountControllerGetDeletionEligibilityResponseSuccess = (adminAccountControllerGetDeletionEligibilityResponse200) & {
  headers: Headers;
};
;

export type adminAccountControllerGetDeletionEligibilityResponse = (adminAccountControllerGetDeletionEligibilityResponseSuccess)

export const getAdminAccountControllerGetDeletionEligibilityUrl = () => {




  return `/api/admin/v1/me/deletion-eligibility`
}

/**
 * @summary アカウント削除可否判定
 */
export const adminAccountControllerGetDeletionEligibility = async ( options?: RequestInit): Promise<adminAccountControllerGetDeletionEligibilityResponse> => {

  return customFetch<adminAccountControllerGetDeletionEligibilityResponse>(getAdminAccountControllerGetDeletionEligibilityUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerAccountControllerGetProfileResponse200 = {
  data: ProfileResponseDto
  status: 200
}

export type providerAccountControllerGetProfileResponseSuccess = (providerAccountControllerGetProfileResponse200) & {
  headers: Headers;
};
;

export type providerAccountControllerGetProfileResponse = (providerAccountControllerGetProfileResponseSuccess)

export const getProviderAccountControllerGetProfileUrl = () => {




  return `/api/provider/v1/me`
}

/**
 * @summary プロフィール取得
 */
export const providerAccountControllerGetProfile = async ( options?: RequestInit): Promise<providerAccountControllerGetProfileResponse> => {

  return customFetch<providerAccountControllerGetProfileResponse>(getProviderAccountControllerGetProfileUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerAccountControllerUpdateProfileResponse200 = {
  data: ProfileResponseDto
  status: 200
}

export type providerAccountControllerUpdateProfileResponseSuccess = (providerAccountControllerUpdateProfileResponse200) & {
  headers: Headers;
};
;

export type providerAccountControllerUpdateProfileResponse = (providerAccountControllerUpdateProfileResponseSuccess)

export const getProviderAccountControllerUpdateProfileUrl = () => {




  return `/api/provider/v1/me`
}

/**
 * @summary プロフィール更新（名前）
 */
export const providerAccountControllerUpdateProfile = async (updateProfileDto: UpdateProfileDto, options?: RequestInit): Promise<providerAccountControllerUpdateProfileResponse> => {

  return customFetch<providerAccountControllerUpdateProfileResponse>(getProviderAccountControllerUpdateProfileUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateProfileDto)
  }
);}



export type providerAccountControllerChangeEmailResponse200 = {
  data: void
  status: 200
}

export type providerAccountControllerChangeEmailResponse401 = {
  data: void
  status: 401
}

export type providerAccountControllerChangeEmailResponse409 = {
  data: void
  status: 409
}

export type providerAccountControllerChangeEmailResponseSuccess = (providerAccountControllerChangeEmailResponse200) & {
  headers: Headers;
};
export type providerAccountControllerChangeEmailResponseError = (providerAccountControllerChangeEmailResponse401 | providerAccountControllerChangeEmailResponse409) & {
  headers: Headers;
};

export type providerAccountControllerChangeEmailResponse = (providerAccountControllerChangeEmailResponseSuccess | providerAccountControllerChangeEmailResponseError)

export const getProviderAccountControllerChangeEmailUrl = () => {




  return `/api/provider/v1/me/change-email`
}

/**
 * @summary メールアドレス変更申請
 */
export const providerAccountControllerChangeEmail = async (changeEmailDto: ChangeEmailDto, options?: RequestInit): Promise<providerAccountControllerChangeEmailResponse> => {

  return customFetch<providerAccountControllerChangeEmailResponse>(getProviderAccountControllerChangeEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeEmailDto)
  }
);}



export type providerAccountControllerVerifyEmailResponse200 = {
  data: void
  status: 200
}

export type providerAccountControllerVerifyEmailResponse400 = {
  data: void
  status: 400
}

export type providerAccountControllerVerifyEmailResponseSuccess = (providerAccountControllerVerifyEmailResponse200) & {
  headers: Headers;
};
export type providerAccountControllerVerifyEmailResponseError = (providerAccountControllerVerifyEmailResponse400) & {
  headers: Headers;
};

export type providerAccountControllerVerifyEmailResponse = (providerAccountControllerVerifyEmailResponseSuccess | providerAccountControllerVerifyEmailResponseError)

export const getProviderAccountControllerVerifyEmailUrl = () => {




  return `/api/provider/v1/me/verify-email`
}

/**
 * @summary メールアドレス変更確認
 */
export const providerAccountControllerVerifyEmail = async (verifyEmailDto: VerifyEmailDto, options?: RequestInit): Promise<providerAccountControllerVerifyEmailResponse> => {

  return customFetch<providerAccountControllerVerifyEmailResponse>(getProviderAccountControllerVerifyEmailUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(verifyEmailDto)
  }
);}



export type providerAccountControllerChangePasswordResponse200 = {
  data: void
  status: 200
}

export type providerAccountControllerChangePasswordResponse401 = {
  data: void
  status: 401
}

export type providerAccountControllerChangePasswordResponseSuccess = (providerAccountControllerChangePasswordResponse200) & {
  headers: Headers;
};
export type providerAccountControllerChangePasswordResponseError = (providerAccountControllerChangePasswordResponse401) & {
  headers: Headers;
};

export type providerAccountControllerChangePasswordResponse = (providerAccountControllerChangePasswordResponseSuccess | providerAccountControllerChangePasswordResponseError)

export const getProviderAccountControllerChangePasswordUrl = () => {




  return `/api/provider/v1/me/change-password`
}

/**
 * @summary パスワード変更
 */
export const providerAccountControllerChangePassword = async (changePasswordDto: ChangePasswordDto, options?: RequestInit): Promise<providerAccountControllerChangePasswordResponse> => {

  return customFetch<providerAccountControllerChangePasswordResponse>(getProviderAccountControllerChangePasswordUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changePasswordDto)
  }
);}



export type invitationAdminControllerCreateResponse201 = {
  data: InvitationResponseDto
  status: 201
}

export type invitationAdminControllerCreateResponse409 = {
  data: void
  status: 409
}

export type invitationAdminControllerCreateResponseSuccess = (invitationAdminControllerCreateResponse201) & {
  headers: Headers;
};
export type invitationAdminControllerCreateResponseError = (invitationAdminControllerCreateResponse409) & {
  headers: Headers;
};

export type invitationAdminControllerCreateResponse = (invitationAdminControllerCreateResponseSuccess | invitationAdminControllerCreateResponseError)

export const getInvitationAdminControllerCreateUrl = () => {




  return `/api/admin/v1/invitations`
}

/**
 * @summary 招待作成
 */
export const invitationAdminControllerCreate = async (createInvitationDto: CreateInvitationDto, options?: RequestInit): Promise<invitationAdminControllerCreateResponse> => {

  return customFetch<invitationAdminControllerCreateResponse>(getInvitationAdminControllerCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInvitationDto)
  }
);}



export type invitationAdminControllerFindAllResponse200 = {
  data: InvitationResponseDto[]
  status: 200
}

export type invitationAdminControllerFindAllResponseSuccess = (invitationAdminControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type invitationAdminControllerFindAllResponse = (invitationAdminControllerFindAllResponseSuccess)

export const getInvitationAdminControllerFindAllUrl = () => {




  return `/api/admin/v1/invitations`
}

/**
 * @summary 招待一覧取得
 */
export const invitationAdminControllerFindAll = async ( options?: RequestInit): Promise<invitationAdminControllerFindAllResponse> => {

  return customFetch<invitationAdminControllerFindAllResponse>(getInvitationAdminControllerFindAllUrl(),
  {
    ...options,
    method: 'GET'


  }
);}



export type invitationAdminControllerDeleteResponse204 = {
  data: void
  status: 204
}

export type invitationAdminControllerDeleteResponse404 = {
  data: void
  status: 404
}

export type invitationAdminControllerDeleteResponseSuccess = (invitationAdminControllerDeleteResponse204) & {
  headers: Headers;
};
export type invitationAdminControllerDeleteResponseError = (invitationAdminControllerDeleteResponse404) & {
  headers: Headers;
};

export type invitationAdminControllerDeleteResponse = (invitationAdminControllerDeleteResponseSuccess | invitationAdminControllerDeleteResponseError)

export const getInvitationAdminControllerDeleteUrl = (id: string,) => {




  return `/api/admin/v1/invitations/${id}`
}

/**
 * @summary 招待削除
 */
export const invitationAdminControllerDelete = async (id: string, options?: RequestInit): Promise<invitationAdminControllerDeleteResponse> => {

  return customFetch<invitationAdminControllerDeleteResponse>(getInvitationAdminControllerDeleteUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type invitationAdminControllerResendResponse201 = {
  data: InvitationResponseDto
  status: 201
}

export type invitationAdminControllerResendResponse404 = {
  data: void
  status: 404
}

export type invitationAdminControllerResendResponseSuccess = (invitationAdminControllerResendResponse201) & {
  headers: Headers;
};
export type invitationAdminControllerResendResponseError = (invitationAdminControllerResendResponse404) & {
  headers: Headers;
};

export type invitationAdminControllerResendResponse = (invitationAdminControllerResendResponseSuccess | invitationAdminControllerResendResponseError)

export const getInvitationAdminControllerResendUrl = (id: string,) => {




  return `/api/admin/v1/invitations/${id}/resend`
}

/**
 * @summary 招待再送
 */
export const invitationAdminControllerResend = async (id: string, options?: RequestInit): Promise<invitationAdminControllerResendResponse> => {

  return customFetch<invitationAdminControllerResendResponse>(getInvitationAdminControllerResendUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}



export type invitationAdminControllerVerifyResponse200 = {
  data: InvitationResponseDto
  status: 200
}

export type invitationAdminControllerVerifyResponse400 = {
  data: void
  status: 400
}

export type invitationAdminControllerVerifyResponse404 = {
  data: void
  status: 404
}

export type invitationAdminControllerVerifyResponseSuccess = (invitationAdminControllerVerifyResponse200) & {
  headers: Headers;
};
export type invitationAdminControllerVerifyResponseError = (invitationAdminControllerVerifyResponse400 | invitationAdminControllerVerifyResponse404) & {
  headers: Headers;
};

export type invitationAdminControllerVerifyResponse = (invitationAdminControllerVerifyResponseSuccess | invitationAdminControllerVerifyResponseError)

export const getInvitationAdminControllerVerifyUrl = (params: InvitationAdminControllerVerifyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/invitations/verify?${stringifiedParams}` : `/api/admin/v1/invitations/verify`
}

/**
 * @summary 招待トークン検証（公開）
 */
export const invitationAdminControllerVerify = async (params: InvitationAdminControllerVerifyParams, options?: RequestInit): Promise<invitationAdminControllerVerifyResponse> => {

  return customFetch<invitationAdminControllerVerifyResponse>(getInvitationAdminControllerVerifyUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type invitationAdminControllerAcceptResponse204 = {
  data: void
  status: 204
}

export type invitationAdminControllerAcceptResponse400 = {
  data: void
  status: 400
}

export type invitationAdminControllerAcceptResponseSuccess = (invitationAdminControllerAcceptResponse204) & {
  headers: Headers;
};
export type invitationAdminControllerAcceptResponseError = (invitationAdminControllerAcceptResponse400) & {
  headers: Headers;
};

export type invitationAdminControllerAcceptResponse = (invitationAdminControllerAcceptResponseSuccess | invitationAdminControllerAcceptResponseError)

export const getInvitationAdminControllerAcceptUrl = () => {




  return `/api/admin/v1/invitations/accept`
}

/**
 * @summary 招待承認（公開）
 */
export const invitationAdminControllerAccept = async (acceptInvitationDto: AcceptInvitationDto, options?: RequestInit): Promise<invitationAdminControllerAcceptResponse> => {

  return customFetch<invitationAdminControllerAcceptResponse>(getInvitationAdminControllerAcceptUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptInvitationDto)
  }
);}



export type tenantInvitationProviderControllerCreateResponse201 = {
  data: InvitationResponseDto
  status: 201
}

export type tenantInvitationProviderControllerCreateResponse400 = {
  data: void
  status: 400
}

export type tenantInvitationProviderControllerCreateResponse404 = {
  data: void
  status: 404
}

export type tenantInvitationProviderControllerCreateResponse409 = {
  data: void
  status: 409
}

export type tenantInvitationProviderControllerCreateResponseSuccess = (tenantInvitationProviderControllerCreateResponse201) & {
  headers: Headers;
};
export type tenantInvitationProviderControllerCreateResponseError = (tenantInvitationProviderControllerCreateResponse400 | tenantInvitationProviderControllerCreateResponse404 | tenantInvitationProviderControllerCreateResponse409) & {
  headers: Headers;
};

export type tenantInvitationProviderControllerCreateResponse = (tenantInvitationProviderControllerCreateResponseSuccess | tenantInvitationProviderControllerCreateResponseError)

export const getTenantInvitationProviderControllerCreateUrl = (params: TenantInvitationProviderControllerCreateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/invitations?${stringifiedParams}` : `/api/provider/v1/invitations`
}

/**
 * @summary テナントユーザー招待作成
 */
export const tenantInvitationProviderControllerCreate = async (createInvitationDto: CreateInvitationDto,
    params: TenantInvitationProviderControllerCreateParams, options?: RequestInit): Promise<tenantInvitationProviderControllerCreateResponse> => {

  return customFetch<tenantInvitationProviderControllerCreateResponse>(getTenantInvitationProviderControllerCreateUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInvitationDto)
  }
);}



export type tenantInvitationProviderControllerFindAllResponse200 = {
  data: InvitationResponseDto[]
  status: 200
}

export type tenantInvitationProviderControllerFindAllResponse400 = {
  data: void
  status: 400
}

export type tenantInvitationProviderControllerFindAllResponse404 = {
  data: void
  status: 404
}

export type tenantInvitationProviderControllerFindAllResponseSuccess = (tenantInvitationProviderControllerFindAllResponse200) & {
  headers: Headers;
};
export type tenantInvitationProviderControllerFindAllResponseError = (tenantInvitationProviderControllerFindAllResponse400 | tenantInvitationProviderControllerFindAllResponse404) & {
  headers: Headers;
};

export type tenantInvitationProviderControllerFindAllResponse = (tenantInvitationProviderControllerFindAllResponseSuccess | tenantInvitationProviderControllerFindAllResponseError)

export const getTenantInvitationProviderControllerFindAllUrl = (params: TenantInvitationProviderControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/invitations?${stringifiedParams}` : `/api/provider/v1/invitations`
}

/**
 * @summary テナントユーザー招待一覧取得
 */
export const tenantInvitationProviderControllerFindAll = async (params: TenantInvitationProviderControllerFindAllParams, options?: RequestInit): Promise<tenantInvitationProviderControllerFindAllResponse> => {

  return customFetch<tenantInvitationProviderControllerFindAllResponse>(getTenantInvitationProviderControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type tenantInvitationProviderControllerCancelResponse204 = {
  data: void
  status: 204
}

export type tenantInvitationProviderControllerCancelResponse400 = {
  data: void
  status: 400
}

export type tenantInvitationProviderControllerCancelResponse404 = {
  data: void
  status: 404
}

export type tenantInvitationProviderControllerCancelResponseSuccess = (tenantInvitationProviderControllerCancelResponse204) & {
  headers: Headers;
};
export type tenantInvitationProviderControllerCancelResponseError = (tenantInvitationProviderControllerCancelResponse400 | tenantInvitationProviderControllerCancelResponse404) & {
  headers: Headers;
};

export type tenantInvitationProviderControllerCancelResponse = (tenantInvitationProviderControllerCancelResponseSuccess | tenantInvitationProviderControllerCancelResponseError)

export const getTenantInvitationProviderControllerCancelUrl = (id: string,
    params: TenantInvitationProviderControllerCancelParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/invitations/${id}?${stringifiedParams}` : `/api/provider/v1/invitations/${id}`
}

/**
 * @summary テナントユーザー招待取消
 */
export const tenantInvitationProviderControllerCancel = async (id: string,
    params: TenantInvitationProviderControllerCancelParams, options?: RequestInit): Promise<tenantInvitationProviderControllerCancelResponse> => {

  return customFetch<tenantInvitationProviderControllerCancelResponse>(getTenantInvitationProviderControllerCancelUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type tenantInvitationProviderControllerResendResponse201 = {
  data: InvitationResponseDto
  status: 201
}

export type tenantInvitationProviderControllerResendResponse400 = {
  data: void
  status: 400
}

export type tenantInvitationProviderControllerResendResponse404 = {
  data: void
  status: 404
}

export type tenantInvitationProviderControllerResendResponseSuccess = (tenantInvitationProviderControllerResendResponse201) & {
  headers: Headers;
};
export type tenantInvitationProviderControllerResendResponseError = (tenantInvitationProviderControllerResendResponse400 | tenantInvitationProviderControllerResendResponse404) & {
  headers: Headers;
};

export type tenantInvitationProviderControllerResendResponse = (tenantInvitationProviderControllerResendResponseSuccess | tenantInvitationProviderControllerResendResponseError)

export const getTenantInvitationProviderControllerResendUrl = (id: string,
    params: TenantInvitationProviderControllerResendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/invitations/${id}/resend?${stringifiedParams}` : `/api/provider/v1/invitations/${id}/resend`
}

/**
 * @summary テナントユーザー招待再送
 */
export const tenantInvitationProviderControllerResend = async (id: string,
    params: TenantInvitationProviderControllerResendParams, options?: RequestInit): Promise<tenantInvitationProviderControllerResendResponse> => {

  return customFetch<tenantInvitationProviderControllerResendResponse>(getTenantInvitationProviderControllerResendUrl(id,params),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminScraperControllerGetActiveJobResponse200 = {
  data: ScraperJobResponseDto
  status: 200
}

export type adminScraperControllerGetActiveJobResponseSuccess = (adminScraperControllerGetActiveJobResponse200) & {
  headers: Headers;
};
;

export type adminScraperControllerGetActiveJobResponse = (adminScraperControllerGetActiveJobResponseSuccess)

export const getAdminScraperControllerGetActiveJobUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/scraper/jobs`
}

/**
 * @summary 進行中または待機中のジョブを取得（直近1件）
 */
export const adminScraperControllerGetActiveJob = async (productId: string, options?: RequestInit): Promise<adminScraperControllerGetActiveJobResponse> => {

  return customFetch<adminScraperControllerGetActiveJobResponse>(getAdminScraperControllerGetActiveJobUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminScraperControllerCreateSessionResponse200 = {
  data: SessionResponseDto
  status: 200
}

export type adminScraperControllerCreateSessionResponseSuccess = (adminScraperControllerCreateSessionResponse200) & {
  headers: Headers;
};
;

export type adminScraperControllerCreateSessionResponse = (adminScraperControllerCreateSessionResponseSuccess)

export const getAdminScraperControllerCreateSessionUrl = (productId: string,) => {




  return `/api/admin/v1/products/${productId}/scraper/sessions`
}

/**
 * @summary セッション作成（sitemap取得+グループ化）
 */
export const adminScraperControllerCreateSession = async (productId: string,
    createSessionDto: CreateSessionDto, options?: RequestInit): Promise<adminScraperControllerCreateSessionResponse> => {

  return customFetch<adminScraperControllerCreateSessionResponse>(getAdminScraperControllerCreateSessionUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSessionDto)
  }
);}



export type adminScraperControllerCreatePreviewResponse200 = {
  data: PreviewResponseDto
  status: 200
}

export type adminScraperControllerCreatePreviewResponseSuccess = (adminScraperControllerCreatePreviewResponse200) & {
  headers: Headers;
};
;

export type adminScraperControllerCreatePreviewResponse = (adminScraperControllerCreatePreviewResponseSuccess)

export const getAdminScraperControllerCreatePreviewUrl = (productId: string,
    sessionId: string,) => {




  return `/api/admin/v1/products/${productId}/scraper/sessions/${sessionId}/preview`
}

/**
 * @summary プレビュー生成（グループ選択+コンテンツ抽出）
 */
export const adminScraperControllerCreatePreview = async (productId: string,
    sessionId: string,
    createPreviewDto: CreatePreviewDto, options?: RequestInit): Promise<adminScraperControllerCreatePreviewResponse> => {

  return customFetch<adminScraperControllerCreatePreviewResponse>(getAdminScraperControllerCreatePreviewUrl(productId,sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createPreviewDto)
  }
);}



export type adminScraperControllerCreateJobResponse202 = {
  data: ScraperJobResponseDto
  status: 202
}

export type adminScraperControllerCreateJobResponseSuccess = (adminScraperControllerCreateJobResponse202) & {
  headers: Headers;
};
;

export type adminScraperControllerCreateJobResponse = (adminScraperControllerCreateJobResponseSuccess)

export const getAdminScraperControllerCreateJobUrl = (productId: string,
    sessionId: string,) => {




  return `/api/admin/v1/products/${productId}/scraper/sessions/${sessionId}/jobs`
}

/**
 * @summary セッションからスクレイピングジョブを作成
 */
export const adminScraperControllerCreateJob = async (productId: string,
    sessionId: string,
    createJobFromSessionDto: CreateJobFromSessionDto, options?: RequestInit): Promise<adminScraperControllerCreateJobResponse> => {

  return customFetch<adminScraperControllerCreateJobResponse>(getAdminScraperControllerCreateJobUrl(productId,sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createJobFromSessionDto)
  }
);}



export type adminScraperControllerGetJobResponse200 = {
  data: ScraperJobResultResponseDto
  status: 200
}

export type adminScraperControllerGetJobResponseSuccess = (adminScraperControllerGetJobResponse200) & {
  headers: Headers;
};
;

export type adminScraperControllerGetJobResponse = (adminScraperControllerGetJobResponseSuccess)

export const getAdminScraperControllerGetJobUrl = (productId: string,
    jobId: string,) => {




  return `/api/admin/v1/products/${productId}/scraper/jobs/${jobId}`
}

/**
 * @summary スクレイピングジョブの進捗を取得
 */
export const adminScraperControllerGetJob = async (productId: string,
    jobId: string, options?: RequestInit): Promise<adminScraperControllerGetJobResponse> => {

  return customFetch<adminScraperControllerGetJobResponse>(getAdminScraperControllerGetJobUrl(productId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminScraperControllerCancelJobResponse200 = {
  data: ScraperJobResponseDto
  status: 200
}

export type adminScraperControllerCancelJobResponseSuccess = (adminScraperControllerCancelJobResponse200) & {
  headers: Headers;
};
;

export type adminScraperControllerCancelJobResponse = (adminScraperControllerCancelJobResponseSuccess)

export const getAdminScraperControllerCancelJobUrl = (productId: string,
    jobId: string,) => {




  return `/api/admin/v1/products/${productId}/scraper/jobs/${jobId}/cancel`
}

/**
 * @summary スクレイピングジョブをキャンセル
 */
export const adminScraperControllerCancelJob = async (productId: string,
    jobId: string, options?: RequestInit): Promise<adminScraperControllerCancelJobResponse> => {

  return customFetch<adminScraperControllerCancelJobResponse>(getAdminScraperControllerCancelJobUrl(productId,jobId),
  {
    ...options,
    method: 'POST'


  }
);}



export type adminSubscriptionControllerGetSubscriptionResponse200 = {
  data: SubscriptionResponseDto
  status: 200
}

export type adminSubscriptionControllerGetSubscriptionResponse403 = {
  data: void
  status: 403
}

export type adminSubscriptionControllerGetSubscriptionResponseSuccess = (adminSubscriptionControllerGetSubscriptionResponse200) & {
  headers: Headers;
};
export type adminSubscriptionControllerGetSubscriptionResponseError = (adminSubscriptionControllerGetSubscriptionResponse403) & {
  headers: Headers;
};

export type adminSubscriptionControllerGetSubscriptionResponse = (adminSubscriptionControllerGetSubscriptionResponseSuccess | adminSubscriptionControllerGetSubscriptionResponseError)

export const getAdminSubscriptionControllerGetSubscriptionUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription`
}

/**
 * @summary サブスクリプション情報取得（ADMIN 限定）
 */
export const adminSubscriptionControllerGetSubscription = async (orgId: string, options?: RequestInit): Promise<adminSubscriptionControllerGetSubscriptionResponse> => {

  return customFetch<adminSubscriptionControllerGetSubscriptionResponse>(getAdminSubscriptionControllerGetSubscriptionUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminSubscriptionControllerGetEntitlementsResponse200 = {
  data: EntitlementDto[]
  status: 200
}

export type adminSubscriptionControllerGetEntitlementsResponseSuccess = (adminSubscriptionControllerGetEntitlementsResponse200) & {
  headers: Headers;
};
;

export type adminSubscriptionControllerGetEntitlementsResponse = (adminSubscriptionControllerGetEntitlementsResponseSuccess)

export const getAdminSubscriptionControllerGetEntitlementsUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/entitlements`
}

/**
 * プラン機能の有効/無効判定（機能ゲーティング）専用の最小レスポンス。課金詳細を含まないため ADMIN/MEMBER どちらも利用可能。
 * @summary プラン機能の利用可否一覧取得（ADMIN/MEMBER 共通）
 */
export const adminSubscriptionControllerGetEntitlements = async (orgId: string, options?: RequestInit): Promise<adminSubscriptionControllerGetEntitlementsResponse> => {

  return customFetch<adminSubscriptionControllerGetEntitlementsResponse>(getAdminSubscriptionControllerGetEntitlementsUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminSubscriptionControllerGetStatusResponse200 = {
  data: SubscriptionStatusDto
  status: 200
}

export type adminSubscriptionControllerGetStatusResponseSuccess = (adminSubscriptionControllerGetStatusResponse200) & {
  headers: Headers;
};
;

export type adminSubscriptionControllerGetStatusResponse = (adminSubscriptionControllerGetStatusResponseSuccess)

export const getAdminSubscriptionControllerGetStatusUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/status`
}

/**
 * accessState のみの最小レスポンス。課金詳細を含まないため ADMIN/MEMBER どちらも利用可能。支払い遅延バナー等、全ロール向けの表示専用。
 * @summary 支払い状態取得（ADMIN/MEMBER 共通）
 */
export const adminSubscriptionControllerGetStatus = async (orgId: string, options?: RequestInit): Promise<adminSubscriptionControllerGetStatusResponse> => {

  return customFetch<adminSubscriptionControllerGetStatusResponse>(getAdminSubscriptionControllerGetStatusUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminSubscriptionControllerUpgradeResponse200 = {
  data: UpgradeAcceptedDto | UpgradeRequiresPaymentMethodDto | UpgradeBankTransferInvoiceIssuedDto
  status: 200
}

export type adminSubscriptionControllerUpgradeResponse403 = {
  data: void
  status: 403
}

export type adminSubscriptionControllerUpgradeResponseSuccess = (adminSubscriptionControllerUpgradeResponse200) & {
  headers: Headers;
};
export type adminSubscriptionControllerUpgradeResponseError = (adminSubscriptionControllerUpgradeResponse403) & {
  headers: Headers;
};

export type adminSubscriptionControllerUpgradeResponse = (adminSubscriptionControllerUpgradeResponseSuccess | adminSubscriptionControllerUpgradeResponseError)

export const getAdminSubscriptionControllerUpgradeUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/upgrade`
}

/**
 * Stripe へ subscription 更新要求を送る。
 * paymentMethod 未指定または CARD の場合は既存挙動: default_payment_method が登録済みなら即時更新、未登録なら Checkout Session URL を返却。
 * paymentMethod=BANK_TRANSFER の場合は Stripe Customer Balance 方式へ切替えて invoice を発行する（hosted_invoice_url で振込先口座を案内）。
 * 未払い open invoice が残っている場合は 409 Conflict (urn:faqrun:error:open-invoice-exists)。
 * @summary プランアップグレード
 */
export const adminSubscriptionControllerUpgrade = async (orgId: string,
    upgradeSubscriptionDto: UpgradeSubscriptionDto, options?: RequestInit): Promise<adminSubscriptionControllerUpgradeResponse> => {

  return customFetch<adminSubscriptionControllerUpgradeResponse>(getAdminSubscriptionControllerUpgradeUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upgradeSubscriptionDto)
  }
);}



export type adminSubscriptionControllerGetDowngradeImpactResponse200 = {
  data: DowngradeImpactResponseDto
  status: 200
}

export type adminSubscriptionControllerGetDowngradeImpactResponseSuccess = (adminSubscriptionControllerGetDowngradeImpactResponse200) & {
  headers: Headers;
};
;

export type adminSubscriptionControllerGetDowngradeImpactResponse = (adminSubscriptionControllerGetDowngradeImpactResponseSuccess)

export const getAdminSubscriptionControllerGetDowngradeImpactUrl = (orgId: string,
    params: AdminSubscriptionControllerGetDowngradeImpactParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/organizations/${orgId}/subscription/downgrade-impact?${stringifiedParams}` : `/api/admin/v1/organizations/${orgId}/subscription/downgrade-impact`
}

/**
 * 指定プランへのダウングレード時に失われる機能・API キー数・カスタムドメイン数、24h 締切判定の結果を返却。確認モーダルでの表示に利用する。
 * @summary ダウングレード影響範囲プレビュー
 */
export const adminSubscriptionControllerGetDowngradeImpact = async (orgId: string,
    params: AdminSubscriptionControllerGetDowngradeImpactParams, options?: RequestInit): Promise<adminSubscriptionControllerGetDowngradeImpactResponse> => {

  return customFetch<adminSubscriptionControllerGetDowngradeImpactResponse>(getAdminSubscriptionControllerGetDowngradeImpactUrl(orgId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type adminSubscriptionControllerDowngradeResponse200 = {
  data: void
  status: 200
}

export type adminSubscriptionControllerDowngradeResponse403 = {
  data: void
  status: 403
}

export type adminSubscriptionControllerDowngradeResponse409 = {
  data: void
  status: 409
}

export type adminSubscriptionControllerDowngradeResponseSuccess = (adminSubscriptionControllerDowngradeResponse200) & {
  headers: Headers;
};
export type adminSubscriptionControllerDowngradeResponseError = (adminSubscriptionControllerDowngradeResponse403 | adminSubscriptionControllerDowngradeResponse409) & {
  headers: Headers;
};

export type adminSubscriptionControllerDowngradeResponse = (adminSubscriptionControllerDowngradeResponseSuccess | adminSubscriptionControllerDowngradeResponseError)

export const getAdminSubscriptionControllerDowngradeUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/downgrade`
}

/**
 * Stripe Subscription Schedule を作成し、次期 billing 期間から新プランへ移行。
 * @summary ダウングレード予約
 */
export const adminSubscriptionControllerDowngrade = async (orgId: string,
    downgradeSubscriptionDto: DowngradeSubscriptionDto, options?: RequestInit): Promise<adminSubscriptionControllerDowngradeResponse> => {

  return customFetch<adminSubscriptionControllerDowngradeResponse>(getAdminSubscriptionControllerDowngradeUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(downgradeSubscriptionDto)
  }
);}



export type adminSubscriptionControllerCancelDowngradeResponse204 = {
  data: void
  status: 204
}

export type adminSubscriptionControllerCancelDowngradeResponse403 = {
  data: void
  status: 403
}

export type adminSubscriptionControllerCancelDowngradeResponse404 = {
  data: void
  status: 404
}

export type adminSubscriptionControllerCancelDowngradeResponseSuccess = (adminSubscriptionControllerCancelDowngradeResponse204) & {
  headers: Headers;
};
export type adminSubscriptionControllerCancelDowngradeResponseError = (adminSubscriptionControllerCancelDowngradeResponse403 | adminSubscriptionControllerCancelDowngradeResponse404) & {
  headers: Headers;
};

export type adminSubscriptionControllerCancelDowngradeResponse = (adminSubscriptionControllerCancelDowngradeResponseSuccess | adminSubscriptionControllerCancelDowngradeResponseError)

export const getAdminSubscriptionControllerCancelDowngradeUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/downgrade-reservation`
}

/**
 * @summary ダウングレード予約キャンセル
 */
export const adminSubscriptionControllerCancelDowngrade = async (orgId: string, options?: RequestInit): Promise<adminSubscriptionControllerCancelDowngradeResponse> => {

  return customFetch<adminSubscriptionControllerCancelDowngradeResponse>(getAdminSubscriptionControllerCancelDowngradeUrl(orgId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type adminSubscriptionControllerUpdatePaymentMethodResponse200 = {
  data: void
  status: 200
}

export type adminSubscriptionControllerUpdatePaymentMethodResponse400 = {
  data: void
  status: 400
}

export type adminSubscriptionControllerUpdatePaymentMethodResponse409 = {
  data: void
  status: 409
}

export type adminSubscriptionControllerUpdatePaymentMethodResponseSuccess = (adminSubscriptionControllerUpdatePaymentMethodResponse200) & {
  headers: Headers;
};
export type adminSubscriptionControllerUpdatePaymentMethodResponseError = (adminSubscriptionControllerUpdatePaymentMethodResponse400 | adminSubscriptionControllerUpdatePaymentMethodResponse409) & {
  headers: Headers;
};

export type adminSubscriptionControllerUpdatePaymentMethodResponse = (adminSubscriptionControllerUpdatePaymentMethodResponseSuccess | adminSubscriptionControllerUpdatePaymentMethodResponseError)

export const getAdminSubscriptionControllerUpdatePaymentMethodUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/payment-method`
}

/**
 * プラン変更を伴わない支払い方法の切替。BANK_TRANSFER → Stripe Customer Balance（JPY バーチャル口座）方式に切替。CARD → charge_automatically に復元（カード登録済みであること）。未払い open invoice が残っている場合は 409 Conflict。
 * @summary 支払い方法変更
 */
export const adminSubscriptionControllerUpdatePaymentMethod = async (orgId: string,
    updatePaymentMethodDto: UpdatePaymentMethodDto, options?: RequestInit): Promise<adminSubscriptionControllerUpdatePaymentMethodResponse> => {

  return customFetch<adminSubscriptionControllerUpdatePaymentMethodResponse>(getAdminSubscriptionControllerUpdatePaymentMethodUrl(orgId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePaymentMethodDto)
  }
);}



export type adminSubscriptionControllerAcceptEnterpriseOfferResponse200 = {
  data: AcceptEnterpriseOfferResponseDto
  status: 200
}

export type adminSubscriptionControllerAcceptEnterpriseOfferResponse400 = {
  data: void
  status: 400
}

export type adminSubscriptionControllerAcceptEnterpriseOfferResponse403 = {
  data: void
  status: 403
}

export type adminSubscriptionControllerAcceptEnterpriseOfferResponse404 = {
  data: void
  status: 404
}

export type adminSubscriptionControllerAcceptEnterpriseOfferResponse409 = {
  data: void
  status: 409
}

export type adminSubscriptionControllerAcceptEnterpriseOfferResponse410 = {
  data: void
  status: 410
}

export type adminSubscriptionControllerAcceptEnterpriseOfferResponseSuccess = (adminSubscriptionControllerAcceptEnterpriseOfferResponse200) & {
  headers: Headers;
};
export type adminSubscriptionControllerAcceptEnterpriseOfferResponseError = (adminSubscriptionControllerAcceptEnterpriseOfferResponse400 | adminSubscriptionControllerAcceptEnterpriseOfferResponse403 | adminSubscriptionControllerAcceptEnterpriseOfferResponse404 | adminSubscriptionControllerAcceptEnterpriseOfferResponse409 | adminSubscriptionControllerAcceptEnterpriseOfferResponse410) & {
  headers: Headers;
};

export type adminSubscriptionControllerAcceptEnterpriseOfferResponse = (adminSubscriptionControllerAcceptEnterpriseOfferResponseSuccess | adminSubscriptionControllerAcceptEnterpriseOfferResponseError)

export const getAdminSubscriptionControllerAcceptEnterpriseOfferUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/enterprise/accept`
}

/**
 * PENDING の Enterprise オファーを承認し、Stripe Subscription を Enterprise プランに切り替える。
 * @summary Enterprise オファーを承認
 */
export const adminSubscriptionControllerAcceptEnterpriseOffer = async (orgId: string,
    acceptEnterpriseOfferDto: AcceptEnterpriseOfferDto, options?: RequestInit): Promise<adminSubscriptionControllerAcceptEnterpriseOfferResponse> => {

  return customFetch<adminSubscriptionControllerAcceptEnterpriseOfferResponse>(getAdminSubscriptionControllerAcceptEnterpriseOfferUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(acceptEnterpriseOfferDto)
  }
);}



export type adminSubscriptionControllerRejectEnterpriseOfferResponse204 = {
  data: void
  status: 204
}

export type adminSubscriptionControllerRejectEnterpriseOfferResponse403 = {
  data: void
  status: 403
}

export type adminSubscriptionControllerRejectEnterpriseOfferResponse404 = {
  data: void
  status: 404
}

export type adminSubscriptionControllerRejectEnterpriseOfferResponseSuccess = (adminSubscriptionControllerRejectEnterpriseOfferResponse204) & {
  headers: Headers;
};
export type adminSubscriptionControllerRejectEnterpriseOfferResponseError = (adminSubscriptionControllerRejectEnterpriseOfferResponse403 | adminSubscriptionControllerRejectEnterpriseOfferResponse404) & {
  headers: Headers;
};

export type adminSubscriptionControllerRejectEnterpriseOfferResponse = (adminSubscriptionControllerRejectEnterpriseOfferResponseSuccess | adminSubscriptionControllerRejectEnterpriseOfferResponseError)

export const getAdminSubscriptionControllerRejectEnterpriseOfferUrl = (orgId: string,) => {




  return `/api/admin/v1/organizations/${orgId}/subscription/enterprise/reject`
}

/**
 * PENDING の Enterprise オファーを辞退する。Stripe 操作は行わない。
 * @summary Enterprise オファーを辞退
 */
export const adminSubscriptionControllerRejectEnterpriseOffer = async (orgId: string,
    rejectEnterpriseOfferDto: RejectEnterpriseOfferDto, options?: RequestInit): Promise<adminSubscriptionControllerRejectEnterpriseOfferResponse> => {

  return customFetch<adminSubscriptionControllerRejectEnterpriseOfferResponse>(getAdminSubscriptionControllerRejectEnterpriseOfferUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(rejectEnterpriseOfferDto)
  }
);}



export type adminSubscriptionControllerGetCustomerPortalUrlResponse200 = {
  data: CustomerPortalResponseDto
  status: 200
}

export type adminSubscriptionControllerGetCustomerPortalUrlResponseSuccess = (adminSubscriptionControllerGetCustomerPortalUrlResponse200) & {
  headers: Headers;
};
;

export type adminSubscriptionControllerGetCustomerPortalUrlResponse = (adminSubscriptionControllerGetCustomerPortalUrlResponseSuccess)

export const getAdminSubscriptionControllerGetCustomerPortalUrlUrl = (orgId: string,
    params: AdminSubscriptionControllerGetCustomerPortalUrlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/v1/organizations/${orgId}/subscription/customer-portal?${stringifiedParams}` : `/api/admin/v1/organizations/${orgId}/subscription/customer-portal`
}

/**
 * 支払い方法変更・請求書ダウンロード等のためのポータル URL を返却。
 * @summary Stripe Customer Portal URL 生成
 */
export const adminSubscriptionControllerGetCustomerPortalUrl = async (orgId: string,
    params: AdminSubscriptionControllerGetCustomerPortalUrlParams, options?: RequestInit): Promise<adminSubscriptionControllerGetCustomerPortalUrlResponse> => {

  return customFetch<adminSubscriptionControllerGetCustomerPortalUrlResponse>(getAdminSubscriptionControllerGetCustomerPortalUrlUrl(orgId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerSubscriptionControllerGetSubscriptionResponse200 = {
  data: SubscriptionResponseDto
  status: 200
}

export type providerSubscriptionControllerGetSubscriptionResponse403 = {
  data: void
  status: 403
}

export type providerSubscriptionControllerGetSubscriptionResponse404 = {
  data: void
  status: 404
}

export type providerSubscriptionControllerGetSubscriptionResponseSuccess = (providerSubscriptionControllerGetSubscriptionResponse200) & {
  headers: Headers;
};
export type providerSubscriptionControllerGetSubscriptionResponseError = (providerSubscriptionControllerGetSubscriptionResponse403 | providerSubscriptionControllerGetSubscriptionResponse404) & {
  headers: Headers;
};

export type providerSubscriptionControllerGetSubscriptionResponse = (providerSubscriptionControllerGetSubscriptionResponseSuccess | providerSubscriptionControllerGetSubscriptionResponseError)

export const getProviderSubscriptionControllerGetSubscriptionUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/subscription`
}

/**
 * 対象 Organization のサブスクリプション状態（currentPlan・entitlements 含む）を返す。
 * @summary サブスクリプション状態を取得
 */
export const providerSubscriptionControllerGetSubscription = async (orgId: string, options?: RequestInit): Promise<providerSubscriptionControllerGetSubscriptionResponse> => {

  return customFetch<providerSubscriptionControllerGetSubscriptionResponse>(getProviderSubscriptionControllerGetSubscriptionUrl(orgId),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerSubscriptionControllerCreateEnterpriseResponse201 = {
  data: EnterpriseOfferResponseDto
  status: 201
}

export type providerSubscriptionControllerCreateEnterpriseResponse400 = {
  data: void
  status: 400
}

export type providerSubscriptionControllerCreateEnterpriseResponse403 = {
  data: void
  status: 403
}

export type providerSubscriptionControllerCreateEnterpriseResponse404 = {
  data: void
  status: 404
}

export type providerSubscriptionControllerCreateEnterpriseResponseSuccess = (providerSubscriptionControllerCreateEnterpriseResponse201) & {
  headers: Headers;
};
export type providerSubscriptionControllerCreateEnterpriseResponseError = (providerSubscriptionControllerCreateEnterpriseResponse400 | providerSubscriptionControllerCreateEnterpriseResponse403 | providerSubscriptionControllerCreateEnterpriseResponse404) & {
  headers: Headers;
};

export type providerSubscriptionControllerCreateEnterpriseResponse = (providerSubscriptionControllerCreateEnterpriseResponseSuccess | providerSubscriptionControllerCreateEnterpriseResponseError)

export const getProviderSubscriptionControllerCreateEnterpriseUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/subscription/enterprise`
}

/**
 * 対象 Organization に Enterprise プランのオファーを作成する。Admin ユーザーが承認すると実際のプラン切替が実行される（2 ステージフロー）。
 * @summary Enterprise オファーを作成
 */
export const providerSubscriptionControllerCreateEnterprise = async (orgId: string,
    createEnterpriseSubscriptionDto: CreateEnterpriseSubscriptionDto, options?: RequestInit): Promise<providerSubscriptionControllerCreateEnterpriseResponse> => {

  return customFetch<providerSubscriptionControllerCreateEnterpriseResponse>(getProviderSubscriptionControllerCreateEnterpriseUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEnterpriseSubscriptionDto)
  }
);}



export type providerSubscriptionControllerChangeEnterprisePriceResponse200 = {
  data: EnterprisePriceChangeResultDto
  status: 200
}

export type providerSubscriptionControllerChangeEnterprisePriceResponse400 = {
  data: void
  status: 400
}

export type providerSubscriptionControllerChangeEnterprisePriceResponse409 = {
  data: void
  status: 409
}

export type providerSubscriptionControllerChangeEnterprisePriceResponseSuccess = (providerSubscriptionControllerChangeEnterprisePriceResponse200) & {
  headers: Headers;
};
export type providerSubscriptionControllerChangeEnterprisePriceResponseError = (providerSubscriptionControllerChangeEnterprisePriceResponse400 | providerSubscriptionControllerChangeEnterprisePriceResponse409) & {
  headers: Headers;
};

export type providerSubscriptionControllerChangeEnterprisePriceResponse = (providerSubscriptionControllerChangeEnterprisePriceResponseSuccess | providerSubscriptionControllerChangeEnterprisePriceResponseError)

export const getProviderSubscriptionControllerChangeEnterprisePriceUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/subscription/enterprise/change-price`
}

/**
 * Enterprise 適用中の Organization に対して料金変更を実行する。
 * @summary Enterprise 料金変更
 */
export const providerSubscriptionControllerChangeEnterprisePrice = async (orgId: string,
    changeEnterprisePriceDto: ChangeEnterprisePriceDto, options?: RequestInit): Promise<providerSubscriptionControllerChangeEnterprisePriceResponse> => {

  return customFetch<providerSubscriptionControllerChangeEnterprisePriceResponse>(getProviderSubscriptionControllerChangeEnterprisePriceUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(changeEnterprisePriceDto)
  }
);}



export type providerSubscriptionControllerCancelEnterprisePriceChangeResponse200 = {
  data: void
  status: 200
}

export type providerSubscriptionControllerCancelEnterprisePriceChangeResponse404 = {
  data: void
  status: 404
}

export type providerSubscriptionControllerCancelEnterprisePriceChangeResponseSuccess = (providerSubscriptionControllerCancelEnterprisePriceChangeResponse200) & {
  headers: Headers;
};
export type providerSubscriptionControllerCancelEnterprisePriceChangeResponseError = (providerSubscriptionControllerCancelEnterprisePriceChangeResponse404) & {
  headers: Headers;
};

export type providerSubscriptionControllerCancelEnterprisePriceChangeResponse = (providerSubscriptionControllerCancelEnterprisePriceChangeResponseSuccess | providerSubscriptionControllerCancelEnterprisePriceChangeResponseError)

export const getProviderSubscriptionControllerCancelEnterprisePriceChangeUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/subscription/enterprise/change-price`
}

/**
 * PENDING のスケジュール料金変更をキャンセルする。
 * @summary Enterprise スケジュール料金変更キャンセル
 */
export const providerSubscriptionControllerCancelEnterprisePriceChange = async (orgId: string, options?: RequestInit): Promise<providerSubscriptionControllerCancelEnterprisePriceChangeResponse> => {

  return customFetch<providerSubscriptionControllerCancelEnterprisePriceChangeResponse>(getProviderSubscriptionControllerCancelEnterprisePriceChangeUrl(orgId),
  {
    ...options,
    method: 'DELETE'


  }
);}



export type providerInternalPlanControllerGrantInternalResponse202 = {
  data: void
  status: 202
}

export type providerInternalPlanControllerGrantInternalResponse400 = {
  data: void
  status: 400
}

export type providerInternalPlanControllerGrantInternalResponse403 = {
  data: void
  status: 403
}

export type providerInternalPlanControllerGrantInternalResponse404 = {
  data: void
  status: 404
}

export type providerInternalPlanControllerGrantInternalResponseSuccess = (providerInternalPlanControllerGrantInternalResponse202) & {
  headers: Headers;
};
export type providerInternalPlanControllerGrantInternalResponseError = (providerInternalPlanControllerGrantInternalResponse400 | providerInternalPlanControllerGrantInternalResponse403 | providerInternalPlanControllerGrantInternalResponse404) & {
  headers: Headers;
};

export type providerInternalPlanControllerGrantInternalResponse = (providerInternalPlanControllerGrantInternalResponseSuccess | providerInternalPlanControllerGrantInternalResponseError)

export const getProviderInternalPlanControllerGrantInternalUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/grant-internal`
}

/**
 * 対象 Organization に INTERNAL プランを付与する。既存 Stripe Subscription は即時 cancel（返金なし）し、$0 INTERNAL Subscription を新規作成する。自己付与可（承認者欄なし）。
 * @summary INTERNAL プランを付与（SUPER_ADMIN のみ）
 */
export const providerInternalPlanControllerGrantInternal = async (orgId: string,
    grantInternalDto: GrantInternalDto, options?: RequestInit): Promise<providerInternalPlanControllerGrantInternalResponse> => {

  return customFetch<providerInternalPlanControllerGrantInternalResponse>(getProviderInternalPlanControllerGrantInternalUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantInternalDto)
  }
);}



export type providerInternalPlanControllerRevokeInternalResponse202 = {
  data: void
  status: 202
}

export type providerInternalPlanControllerRevokeInternalResponse403 = {
  data: void
  status: 403
}

export type providerInternalPlanControllerRevokeInternalResponse404 = {
  data: void
  status: 404
}

export type providerInternalPlanControllerRevokeInternalResponseSuccess = (providerInternalPlanControllerRevokeInternalResponse202) & {
  headers: Headers;
};
export type providerInternalPlanControllerRevokeInternalResponseError = (providerInternalPlanControllerRevokeInternalResponse403 | providerInternalPlanControllerRevokeInternalResponse404) & {
  headers: Headers;
};

export type providerInternalPlanControllerRevokeInternalResponse = (providerInternalPlanControllerRevokeInternalResponseSuccess | providerInternalPlanControllerRevokeInternalResponseError)

export const getProviderInternalPlanControllerRevokeInternalUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/revoke-internal`
}

/**
 * 対象 Organization の INTERNAL プランを剥奪する。現 $0 INTERNAL Subscription は即時 cancel し、FREE Subscription を新規作成する。有料機能は FREE プランの entitlement に従って自動的に無効化される。
 * @summary INTERNAL プランを剥奪し FREE プランに戻す（SUPER_ADMIN のみ）
 */
export const providerInternalPlanControllerRevokeInternal = async (orgId: string,
    grantInternalDto: GrantInternalDto, options?: RequestInit): Promise<providerInternalPlanControllerRevokeInternalResponse> => {

  return customFetch<providerInternalPlanControllerRevokeInternalResponse>(getProviderInternalPlanControllerRevokeInternalUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(grantInternalDto)
  }
);}



export type providerPlanControllerFindAllResponse200 = {
  data: PaginatedPlanResponseDto
  status: 200
}

export type providerPlanControllerFindAllResponseSuccess = (providerPlanControllerFindAllResponse200) & {
  headers: Headers;
};
;

export type providerPlanControllerFindAllResponse = (providerPlanControllerFindAllResponseSuccess)

export const getProviderPlanControllerFindAllUrl = (params?: ProviderPlanControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/plans?${stringifiedParams}` : `/api/provider/v1/plans`
}

/**
 * @summary プラン一覧取得（全 ProviderRole 可）
 */
export const providerPlanControllerFindAll = async (params?: ProviderPlanControllerFindAllParams, options?: RequestInit): Promise<providerPlanControllerFindAllResponse> => {

  return customFetch<providerPlanControllerFindAllResponse>(getProviderPlanControllerFindAllUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerPlanControllerSyncFromStripeResponse200 = {
  data: void
  status: 200
}

export type providerPlanControllerSyncFromStripeResponse403 = {
  data: void
  status: 403
}

export type providerPlanControllerSyncFromStripeResponseSuccess = (providerPlanControllerSyncFromStripeResponse200) & {
  headers: Headers;
};
export type providerPlanControllerSyncFromStripeResponseError = (providerPlanControllerSyncFromStripeResponse403) & {
  headers: Headers;
};

export type providerPlanControllerSyncFromStripeResponse = (providerPlanControllerSyncFromStripeResponseSuccess | providerPlanControllerSyncFromStripeResponseError)

export const getProviderPlanControllerSyncFromStripeUrl = () => {




  return `/api/provider/v1/plans/sync`
}

/**
 * @summary Stripe からプラン情報を同期（SUPER_ADMIN / OPERATOR）
 */
export const providerPlanControllerSyncFromStripe = async ( options?: RequestInit): Promise<providerPlanControllerSyncFromStripeResponse> => {

  return customFetch<providerPlanControllerSyncFromStripeResponse>(getProviderPlanControllerSyncFromStripeUrl(),
  {
    ...options,
    method: 'POST'


  }
);}



export type providerPlanControllerFindByIdResponse200 = {
  data: PlanDetailResponseDto
  status: 200
}

export type providerPlanControllerFindByIdResponse404 = {
  data: void
  status: 404
}

export type providerPlanControllerFindByIdResponseSuccess = (providerPlanControllerFindByIdResponse200) & {
  headers: Headers;
};
export type providerPlanControllerFindByIdResponseError = (providerPlanControllerFindByIdResponse404) & {
  headers: Headers;
};

export type providerPlanControllerFindByIdResponse = (providerPlanControllerFindByIdResponseSuccess | providerPlanControllerFindByIdResponseError)

export const getProviderPlanControllerFindByIdUrl = (planId: string,) => {




  return `/api/provider/v1/plans/${planId}`
}

/**
 * @summary プラン詳細取得（全 ProviderRole 可）
 */
export const providerPlanControllerFindById = async (planId: string, options?: RequestInit): Promise<providerPlanControllerFindByIdResponse> => {

  return customFetch<providerPlanControllerFindByIdResponse>(getProviderPlanControllerFindByIdUrl(planId),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerProductControllerFindAllResponse200 = {
  data: PaginatedProductResponseDto
  status: 200
}

export type providerProductControllerFindAllResponse404 = {
  data: void
  status: 404
}

export type providerProductControllerFindAllResponseSuccess = (providerProductControllerFindAllResponse200) & {
  headers: Headers;
};
export type providerProductControllerFindAllResponseError = (providerProductControllerFindAllResponse404) & {
  headers: Headers;
};

export type providerProductControllerFindAllResponse = (providerProductControllerFindAllResponseSuccess | providerProductControllerFindAllResponseError)

export const getProviderProductControllerFindAllUrl = (orgId: string,
    params?: ProviderProductControllerFindAllParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/provider/v1/organizations/${orgId}/products?${stringifiedParams}` : `/api/provider/v1/organizations/${orgId}/products`
}

/**
 * @summary 組織配下のプロダクト一覧取得
 */
export const providerProductControllerFindAll = async (orgId: string,
    params?: ProviderProductControllerFindAllParams, options?: RequestInit): Promise<providerProductControllerFindAllResponse> => {

  return customFetch<providerProductControllerFindAllResponse>(getProviderProductControllerFindAllUrl(orgId,params),
  {
    ...options,
    method: 'GET'


  }
);}



export type providerProductControllerCreateResponse201 = {
  data: ProductResponseDto
  status: 201
}

export type providerProductControllerCreateResponse403 = {
  data: void
  status: 403
}

export type providerProductControllerCreateResponse404 = {
  data: void
  status: 404
}

export type providerProductControllerCreateResponseSuccess = (providerProductControllerCreateResponse201) & {
  headers: Headers;
};
export type providerProductControllerCreateResponseError = (providerProductControllerCreateResponse403 | providerProductControllerCreateResponse404) & {
  headers: Headers;
};

export type providerProductControllerCreateResponse = (providerProductControllerCreateResponseSuccess | providerProductControllerCreateResponseError)

export const getProviderProductControllerCreateUrl = (orgId: string,) => {




  return `/api/provider/v1/organizations/${orgId}/products`
}

/**
 * @summary プロダクト作成
 */
export const providerProductControllerCreate = async (orgId: string,
    createProductDto: CreateProductDto, options?: RequestInit): Promise<providerProductControllerCreateResponse> => {

  return customFetch<providerProductControllerCreateResponse>(getProviderProductControllerCreateUrl(orgId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductDto)
  }
);}



